import React, { useState, useEffect } from 'react';
import { Search, X, Zap, Gift, DollarSign, Bookmark, Users, LogIn, User, Package, Printer, ChevronRight, Copy, Check } from 'lucide-react';
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, onValue } from 'firebase/database';
import BattleArena from './BattleArena';

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyARv3RMmZCBVru7_sjwxNDt9HO5PxbAtx4",
  authDomain: "cheeks-live-status.firebaseapp.com",
  databaseURL: "https://cheeks-live-status-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "cheeks-live-status",
  storageBucket: "cheeks-live-status.firebasestorage.app",
  messagingSenderId: "743249460847",
  appId: "1:747249460847:web:46f2d8835c19ca8effd79a"
};

// Initialise Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

// Special non-Pokédex character for the Card Builder, using the site's own profile picture as its sprite
const TOGECHEEKS_ENTRY = { id: 'togecheeks', name: 'togecheeks' };

const CardExplorer = () => {
  const [isLive, setIsLive] = useState(false);
  const [memberCount, setMemberCount] = useState(null);
  const [voiceCount, setVoiceCount] = useState(0);
  const [instagramCount, setInstagramCount] = useState(null);
  const [whatnotCount, setWhatnotCount] = useState(null);
  const [bannerText, setBannerText] = useState('');
  const [myStatus, setMyStatus] = useState('');
  const [myPresence, setMyPresence] = useState(null);
  const [myBadges, setMyBadges] = useState([]);
  const [myActivity, setMyActivity] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [discordUser, setDiscordUser] = useState(() => {
    try {
      const saved = localStorage.getItem('discordUser');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [loginErrorVisible, setLoginErrorVisible] = useState(false);
  const [showPogoModal, setShowPogoModal] = useState(false);
  const [showHearts, setShowHearts] = useState(false);
  const [showCopiedToast, setShowCopiedToast] = useState(false);
  const [selectedSocialBar, setSelectedSocialBar] = useState(null);
  const [funFact, setFunFact] = useState('');

  useEffect(() => {
    fetch('https://pokefacts.vercel.app/')
      .then(r => r.json())
      .then(d => setFunFact(d.data?.[0] || ''))
      .catch(() => {});
  }, []);

  // Badge definitions — keyed by role name, with image path and display label

  useEffect(() => {
    const t = setTimeout(() => { setShowHearts(true); }, 800);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    setLoginErrorVisible(true);
    const fade = setTimeout(() => setLoginErrorVisible(false), 4500);
    const clear = setTimeout(() => setLoginError(false), 5000);
    return () => { clearTimeout(fade); clearTimeout(clear); };
  }, [loginError]);

  // Tab state — 'profile', 'creations', 'battle', 'builder', or 'inventory'
  const VALID_TABS = ['profile', 'creations', 'battle', 'builder', 'inventory'];
  const TAB_LIST = [
    { id: 'profile',   label: 'Profile',   path: <><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></> },
    { id: 'creations', label: 'Creations', path: <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/> },
    { id: 'builder',   label: 'Builder',   path: <><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></> },
    { id: 'battle',    label: 'Battle',    path: <><path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"/><path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/><path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"/><path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"/><path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"/><path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"/><path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"/><path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"/></> },
    { id: 'inventory', label: 'Inventory', path: <><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></> },
  ];
  const getInitialTab = () => {
    const hash = window.location.hash.replace('#', '');
    return VALID_TABS.includes(hash) ? hash : 'profile';
  };
  const [activeTab, setActiveTab] = useState(getInitialTab);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      if (VALID_TABS.includes(hash)) {
        setActiveTab(hash);
      }
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  const [expandedInstructions, setExpandedInstructions] = useState(null);
  const [expandedFirmware, setExpandedFirmware] = useState(null);
  const [firmwareState, setFirmwareState] = useState('disconnected');
  const [firmwareProgress, setFirmwareProgress] = useState(0);
  const [serialPort, setSerialPort] = useState(null);
  const [serialWriter, setSerialWriter] = useState(null);
  const [deviceVersion, setDeviceVersion] = useState(null);
  const [deviceName, setDeviceName] = useState(null);
  const LATEST_VERSION = 'v1.2.4';
  const OTA_URL = 'https://cheeks.uk/firmware/latest.bin';

  const readLines = async (reader, onLine, timeoutMs = 4000) => {
    let buf = '';
    const deadline = Date.now() + timeoutMs;
    while (Date.now() < deadline) {
      const { value, done } = await reader.read();
      if (done) break;
      buf += new TextDecoder().decode(value);
      const parts = buf.split('\n');
      buf = parts.pop();
      for (const line of parts) {
        const trimmed = line.trim();
        if (trimmed) { const stop = onLine(trimmed); if (stop) return; }
      }
    }
  };

  const connectSerial = async () => {
    if (!('serial' in navigator)) { setFirmwareState('unsupported'); return; }
    try {
      const port = await navigator.serial.requestPort({ filters: [{ usbVendorId: 0x303a }] });
      await port.open({ baudRate: 115200 });
      setFirmwareState('connecting');
      const writer = port.writable.getWriter();
      const reader = port.readable.getReader();
      await writer.write(new TextEncoder().encode('VERSION\n'));
      let ver = 'v1.0.0', name = 'Digital Display Stand';
      await readLines(reader, (line) => {
        if (line.startsWith('VERSION:')) ver = line.replace('VERSION:', '').trim();
        if (line.startsWith('NAME:')) name = line.replace('NAME:', '').trim();
        if (line === 'OK') return true;
      }, 3000);
      reader.releaseLock();
      setSerialPort(port);
      setSerialWriter(writer);
      setDeviceVersion(ver);
      setDeviceName(name);
      setFirmwareState('connected');
    } catch(e) {
      if (e.name !== 'NotFoundError') setFirmwareState('disconnected');
    }
  };

  const disconnectSerial = async () => {
    try { if (serialWriter) serialWriter.releaseLock(); } catch(e) {}
    try { if (serialPort) await serialPort.close(); } catch(e) {}
    setSerialPort(null); setSerialWriter(null);
    setDeviceVersion(null); setDeviceName(null);
    setFirmwareState('disconnected');
  };

  const runOTA = async () => {
    if (!serialPort || !serialWriter) return;
    setFirmwareState('updating');
    setFirmwareProgress(0);
    try {
      await serialWriter.write(new TextEncoder().encode(`OTA:${OTA_URL}\n`));
      const reader = serialPort.readable.getReader();
      await readLines(reader, (line) => {
        if (line.startsWith('OTA_PROGRESS:')) {
          const pct = parseInt(line.replace('OTA_PROGRESS:', ''));
          setFirmwareProgress(pct);
        } else if (line === 'OTA_DONE') {
          setFirmwareProgress(100);
          setFirmwareState('done');
          return true;
        } else if (line.startsWith('OTA_ERROR:')) {
          const msg = line.replace('OTA_ERROR:', '');
          console.error('OTA error:', msg);
          setFirmwareState('error');
          return true;
        }
      }, 120000); // 2 min timeout for the actual flash
      reader.releaseLock();
    } catch(e) {
      console.error('OTA exception:', e);
      setFirmwareState('error');
    }
  };
  const [displayImageIndex, setDisplayImageIndex] = useState(0);
  const [selectedStandImage, setSelectedStandImage] = useState('/digital_stand.png');
  const [selectedInventoryImage, setSelectedInventoryImage] = useState(null);

  // ── Card Builder state ──────────────────────────────────────────────
  // Each type carries its own matching card theme — background always follows the chosen type
  const cardTypes = [
    { id: 'Fairy',     color: '#ec4899', weak: 'Metal',     theme: { gradient: 'linear-gradient(160deg, #fce7f3 0%, #f472b6 55%, #db2777 100%)', border: '#be185d' } },
    { id: 'Grass',     color: '#4ade80', weak: 'Fire',      theme: { gradient: 'linear-gradient(160deg, #bbf7d0 0%, #22c55e 55%, #15803d 100%)', border: '#14532d' } },
    { id: 'Fire',      color: '#f97316', weak: 'Water',     theme: { gradient: 'linear-gradient(160deg, #fed7aa 0%, #f97316 55%, #b91c1c 100%)', border: '#7c2d12' } },
    { id: 'Water',     color: '#38bdf8', weak: 'Lightning', theme: { gradient: 'linear-gradient(160deg, #bae6fd 0%, #38bdf8 55%, #1d4ed8 100%)', border: '#1e3a8a' } },
    { id: 'Lightning', color: '#facc15', weak: 'Fighting',  theme: { gradient: 'linear-gradient(160deg, #fef9c3 0%, #facc15 55%, #b45309 100%)', border: '#78350f' } },
    { id: 'Psychic',   color: '#f472b6', weak: 'Darkness',  theme: { gradient: 'linear-gradient(160deg, #fbcfe8 0%, #ec4899 55%, #a21caf 100%)', border: '#701a75' } },
    { id: 'Fighting',  color: '#b45309', weak: 'Psychic',   theme: { gradient: 'linear-gradient(160deg, #fde68a 0%, #b45309 55%, #7c2d12 100%)', border: '#451a03' } },
    { id: 'Darkness',  color: '#475569', weak: 'Grass',     theme: { gradient: 'linear-gradient(160deg, #94a3b8 0%, #475569 55%, #0f172a 100%)', border: '#020617' } },
    { id: 'Metal',     color: '#94a3b8', weak: 'Fire',      theme: { gradient: 'linear-gradient(160deg, #e2e8f0 0%, #94a3b8 55%, #475569 100%)', border: '#334155' } },
    { id: 'Dragon',    color: '#818cf8', weak: 'Fairy',     theme: { gradient: 'linear-gradient(160deg, #c7d2fe 0%, #818cf8 55%, #4338ca 100%)', border: '#312e81' } },
    { id: 'Colorless', color: '#e5e7eb', weak: 'Fighting',  theme: { gradient: 'linear-gradient(160deg, #f8fafc 0%, #e2e8f0 55%, #94a3b8 100%)', border: '#64748b' } },
  ];
  // Small decorative glyph shown inside each type's energy badge — purely cosmetic
  const typeIconGlyph = (typeId) => {
    switch (typeId) {
      case 'Fire':      return <path d="M12 2.5c-.9 2.7-3.3 3.7-3.3 6.8a3.3 3.3 0 006.6 0c0-.8-.3-1.4-.6-2 1 1 1.8 2.5 1.8 4a4.5 4.5 0 01-9 0c0-3.7 2.9-5.6 4.5-8.8z"/>;
      case 'Water':     return <path d="M12 2.8s5 5.8 5 9.7a5 5 0 01-10 0c0-3.9 5-9.7 5-9.7z"/>;
      case 'Grass':     return <path d="M12 2.8c3.3 1.7 5.5 4.4 5.5 7.7a5.5 5.5 0 01-11 0c0-3.3 2.2-6 5.5-7.7z"/>;
      case 'Lightning': return <polygon points="13 2 4.5 14 10.5 14 9.5 22 19.5 9.5 12.5 9.5 12.5 2" />;
      case 'Psychic':   return <><circle cx="12" cy="12" r="4.5"/><circle cx="12" cy="12" r="7.5" fill="none" stroke="white" strokeWidth="1"/></>;
      case 'Fighting':  return <path d="M12 3l4.2 6.5H13v9.5h-2V9.5H7.8z"/>;
      case 'Darkness':  return <path d="M19.5 13.5A7.5 7.5 0 1110.5 4.5a6 6 0 009 9z"/>;
      case 'Metal':     return <rect x="6.5" y="6.5" width="11" height="11" rx="2.5"/>;
      case 'Fairy':     return <path d="M12 2.8l1.9 5.3 5.3 1.9-5.3 1.9L12 17l-1.9-5.1-5.3-1.9 5.3-1.9z"/>;
      case 'Dragon':    return <path d="M3.5 17c4.5-1 5.5-9.5 8.5-12 2 4.2 6.2 5.2 8.5 3-2 5.5-7.5 7.5-9.5 11.5-1-2-4-2.2-7.5-2.5z"/>;
      default:          return <circle cx="12" cy="12" r="4.5"/>;
    }
  };
  // Illustrated scene backgrounds — purely decorative, layered over the type-colour gradient
  const cardScenes = [
    { id: 'none',    name: 'Plain' },
    { id: 'beach',   name: 'Beach' },
    { id: 'forest',  name: 'Forest' },
    { id: 'night',   name: 'Night Sky' },
    { id: 'volcano', name: 'Volcano' },
  ];
  const sceneArt = (sceneId) => {
    switch (sceneId) {
      case 'beach':
        return (
          <svg viewBox="0 0 300 420" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 w-full h-full">
            <defs>
              <linearGradient id="beachSky" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#7dd3fc" />
                <stop offset="100%" stopColor="#e0f2fe" />
              </linearGradient>
              <linearGradient id="beachSand" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#fde68a" />
                <stop offset="100%" stopColor="#eab676" />
              </linearGradient>
            </defs>
            <rect x="0" y="0" width="300" height="260" fill="url(#beachSky)" />
            <circle cx="228" cy="72" r="32" fill="#fef08a" />
            <rect x="0" y="230" width="300" height="190" fill="#38bdf8" />
            <path d="M0 250 Q75 230 150 250 T300 250 V420 H0 Z" fill="url(#beachSand)" />
            <path d="M0 240 Q75 225 150 240 T300 240" stroke="white" strokeOpacity="0.55" strokeWidth="4" fill="none" />
            <path d="M28 420 C28 360 34 320 40 300" stroke="#7c4a24" strokeWidth="7" fill="none" strokeLinecap="round" />
            <path d="M40 300 C20 285 10 270 5 255" stroke="#15803d" strokeWidth="8" fill="none" strokeLinecap="round" />
            <path d="M40 300 C55 280 65 262 68 248" stroke="#15803d" strokeWidth="8" fill="none" strokeLinecap="round" />
            <path d="M40 300 C42 278 48 258 58 240" stroke="#16a34a" strokeWidth="8" fill="none" strokeLinecap="round" />
            <path d="M40 300 C30 282 22 262 20 244" stroke="#16a34a" strokeWidth="8" fill="none" strokeLinecap="round" />
          </svg>
        );
      case 'forest':
        return (
          <svg viewBox="0 0 300 420" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 w-full h-full">
            <defs>
              <linearGradient id="forestSky" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#bbf7d0" />
                <stop offset="100%" stopColor="#f0fdf4" />
              </linearGradient>
            </defs>
            <rect x="0" y="0" width="300" height="420" fill="url(#forestSky)" />
            <rect x="0" y="300" width="300" height="120" fill="#4d7c0f" />
            <g opacity="0.55">
              <rect x="16" y="260" width="8" height="60" fill="#65a30d" />
              <polygon points="-10,260 50,260 20,190" fill="#65a30d" />
              <rect x="166" y="260" width="8" height="60" fill="#65a30d" />
              <polygon points="140,260 200,260 170,190" fill="#65a30d" />
              <rect x="266" y="260" width="8" height="60" fill="#65a30d" />
              <polygon points="240,260 310,260 270,190" fill="#65a30d" />
            </g>
            <g>
              <rect x="50" y="280" width="10" height="90" fill="#365314" />
              <polygon points="15,290 95,290 55,200" fill="#166534" />
              <polygon points="23,250 87,250 55,170" fill="#15803d" />
              <rect x="220" y="280" width="10" height="90" fill="#365314" />
              <polygon points="185,290 265,290 225,200" fill="#166534" />
              <polygon points="193,250 257,250 225,170" fill="#15803d" />
            </g>
          </svg>
        );
      case 'night':
        return (
          <svg viewBox="0 0 300 420" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 w-full h-full">
            <defs>
              <linearGradient id="nightSky" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#1e1b4b" />
                <stop offset="100%" stopColor="#312e81" />
              </linearGradient>
            </defs>
            <rect x="0" y="0" width="300" height="420" fill="url(#nightSky)" />
            {[[20,30],[60,80],[100,40],[140,110],[180,60],[220,90],[260,35],[35,150],[90,180],[150,160],[210,200],[250,140]].map(([x,y],i) => (
              <circle key={i} cx={x} cy={y} r={i % 3 === 0 ? 1.8 : 1} fill="white" opacity={0.5 + (i % 4) * 0.12} />
            ))}
            <circle cx="228" cy="80" r="28" fill="#fef9c3" />
            <circle cx="240" cy="70" r="24" fill="#1e1b4b" />
            <polygon points="0,420 40,320 80,380 130,300 180,380 230,330 300,420" fill="#0f172a" />
          </svg>
        );
      case 'volcano':
        return (
          <svg viewBox="0 0 300 420" preserveAspectRatio="xMidYMid slice" className="absolute inset-0 w-full h-full">
            <defs>
              <linearGradient id="volcanoSky" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#7c2d12" />
                <stop offset="60%" stopColor="#f97316" />
                <stop offset="100%" stopColor="#450a0a" />
              </linearGradient>
              <radialGradient id="volcanoGlow" cx="50%" cy="30%" r="50%">
                <stop offset="0%" stopColor="#fde047" />
                <stop offset="100%" stopColor="#f97316" stopOpacity="0" />
              </radialGradient>
            </defs>
            <rect x="0" y="0" width="300" height="420" fill="url(#volcanoSky)" />
            <rect x="0" y="0" width="300" height="420" fill="url(#volcanoGlow)" />
            <polygon points="150,120 230,340 70,340" fill="#3f3f46" />
            <polygon points="150,120 190,220 110,220" fill="#f97316" />
            <ellipse cx="150" cy="115" rx="26" ry="10" fill="#78716c" opacity="0.6" />
            <ellipse cx="130" cy="90" rx="34" ry="12" fill="#a8a29e" opacity="0.5" />
            <rect x="0" y="330" width="300" height="90" fill="#1c1917" />
          </svg>
        );
      default:
        return null;
    }
  };
  const spriteStyles = [
    { id: 'official-artwork', name: 'Official Art', folder: 'other/official-artwork' },
    { id: 'home',             name: 'Home',         folder: 'other/home' },
    { id: 'default',          name: 'Classic',       folder: '' },
  ];
  const [builderScene, setBuilderScene] = useState('beach');
  const [builderSpriteStyle, setBuilderSpriteStyle] = useState(spriteStyles[0].id);
  const [builderPokemonList, setBuilderPokemonList] = useState([TOGECHEEKS_ENTRY]);
  const [builderPokemonSearch, setBuilderPokemonSearch] = useState('');
  const [builderShowPokemonPicker, setBuilderShowPokemonPicker] = useState(false);
  const [builderSelectedPokemon, setBuilderSelectedPokemon] = useState(TOGECHEEKS_ENTRY); // { id, name }
  const [builderCardName, setBuilderCardName] = useState('Togecheeks');
  const [builderHp, setBuilderHp] = useState('120');
  const [builderType, setBuilderType] = useState(cardTypes[0].id);
  const [builderMoveName, setBuilderMoveName] = useState('Clap');
  const [builderMoveDesc, setBuilderMoveDesc] = useState('You already know...');
  const [builderDamage, setBuilderDamage] = useState('10');
  const [builderCardNumberInput, setBuilderCardNumberInput] = useState('420/151');
  const [builderLoadCodeInput, setBuilderLoadCodeInput] = useState('');
  const [builderLoadCodeError, setBuilderLoadCodeError] = useState('');
  const [builderCodeCopied, setBuilderCodeCopied] = useState(false);

  useEffect(() => {
    fetch('https://pokeapi.co/api/v2/pokemon?limit=1025')
      .then(r => r.json())
      .then(d => {
        const list = (d.results || []).map(p => {
          const match = p.url.match(/\/pokemon\/(\d+)\//);
          return { name: p.name, id: match ? parseInt(match[1], 10) : null };
        }).filter(p => p.id);
        setBuilderPokemonList([TOGECHEEKS_ENTRY, ...list]);
      })
      .catch(() => {});
  }, []);

  const pokemonSpriteUrl = (id, styleId = builderSpriteStyle) => {
    if (id === 'togecheeks') return '/pfp.png';
    const style = spriteStyles.find(s => s.id === styleId) || spriteStyles[0];
    const path = style.folder ? `${style.folder}/${id}.png` : `${id}.png`;
    return `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${path}`;
  };

  const filteredBuilderPokemon = builderPokemonSearch.trim()
    ? builderPokemonList.filter(p => p.name.includes(builderPokemonSearch.trim().toLowerCase())).slice(0, 30)
    : [];

  // Compact code format: index|index|id|hp|name|moveName|moveDesc, joined with a control
  // character (never typed by users) then base64url'd. No pokemonName or full type/bg
  // strings — those are derived back from their index/id on decode, keeping the code short.
  const CODE_SEP = '';

  const encodeCardCode = ({ pokemonId, typeIndex, sceneIndex, spriteIndex, name, hp, moveName, moveDesc, damage, cardNumber }) => {
    const payload = [pokemonId, typeIndex, sceneIndex, spriteIndex, hp, name, moveName, moveDesc, damage, cardNumber].join(CODE_SEP);
    return btoa(unescape(encodeURIComponent(payload)))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
  };

  const decodeCardCode = (code) => {
    try {
      let b64 = code.trim().replace(/-/g, '+').replace(/_/g, '/');
      b64 += '='.repeat((4 - (b64.length % 4)) % 4);
      const payload = decodeURIComponent(escape(atob(b64)));
      const [pokemonId, typeIndex, sceneIndex, spriteIndex, hp, name, moveName, moveDesc, damage, cardNumber] = payload.split(CODE_SEP);
      const type = cardTypes[parseInt(typeIndex, 10)];
      const scene = cardScenes[parseInt(sceneIndex, 10)];
      const sprite = spriteStyles[parseInt(spriteIndex, 10)];
      if (!type || !scene || !sprite) return null;
      // pokemonId is usually a Pokédex number, but the special Togecheeks entry uses a non-numeric id
      const parsedPokemonId = pokemonId === 'togecheeks' ? 'togecheeks' : parseInt(pokemonId, 10);
      return { pokemonId: parsedPokemonId, typeId: type.id, sceneId: scene.id, spriteId: sprite.id, hp, name, moveName, moveDesc, damage: damage || '', cardNumber: cardNumber || '' };
    } catch {
      return null;
    }
  };

  const builderCode = (builderSelectedPokemon && builderCardName.trim())
    ? encodeCardCode({
        pokemonId: builderSelectedPokemon.id,
        typeIndex: cardTypes.findIndex(t => t.id === builderType),
        sceneIndex: cardScenes.findIndex(s => s.id === builderScene),
        spriteIndex: spriteStyles.findIndex(s => s.id === builderSpriteStyle),
        name: builderCardName.trim(),
        hp: builderHp,
        moveName: builderMoveName,
        moveDesc: builderMoveDesc,
        damage: builderDamage.trim(),
        cardNumber: builderCardNumberInput.trim(),
      })
    : '';

  const handleCopyBuilderCode = () => {
    if (!builderCode) return;
    navigator.clipboard.writeText(builderCode).then(() => {
      setBuilderCodeCopied(true);
      setTimeout(() => setBuilderCodeCopied(false), 1800);
    }).catch(() => {});
  };

  const handleLoadBuilderCode = async () => {
    const decoded = decodeCardCode(builderLoadCodeInput);
    if (!decoded) {
      setBuilderLoadCodeError('That code doesn\'t look right — double check and try again.');
      return;
    }
    setBuilderLoadCodeError('');
    setBuilderCardName(decoded.name);
    setBuilderHp(decoded.hp);
    setBuilderType(decoded.typeId);
    setBuilderScene(decoded.sceneId);
    setBuilderSpriteStyle(decoded.spriteId);
    setBuilderMoveName(decoded.moveName);
    setBuilderMoveDesc(decoded.moveDesc);
    setBuilderDamage(decoded.damage);
    setBuilderCardNumberInput(decoded.cardNumber);
    setBuilderLoadCodeInput('');

    const known = builderPokemonList.find(p => p.id === decoded.pokemonId);
    if (known || decoded.pokemonId === 'togecheeks') {
      setBuilderSelectedPokemon(known || TOGECHEEKS_ENTRY);
      return;
    }
    try {
      const r = await fetch(`https://pokeapi.co/api/v2/pokemon/${decoded.pokemonId}`);
      const d = await r.json();
      setBuilderSelectedPokemon({ id: decoded.pokemonId, name: d.name });
    } catch {
      setBuilderSelectedPokemon({ id: decoded.pokemonId, name: `pokemon-${decoded.pokemonId}` });
    }
  };

  const selectedBuilderType = cardTypes.find(t => t.id === builderType) || cardTypes[0];
  const selectedBuilderBackground = selectedBuilderType.theme;
  // Sensible auto defaults — shown unless the user types their own override below
  const builderAutoDamage = builderHp ? Math.max(10, Math.round((parseInt(builderHp, 10) * 0.7) / 10) * 10) : 30;
  const builderAutoCardNumber = (builderSelectedPokemon && Number.isFinite(builderSelectedPokemon.id))
    ? `${String(builderSelectedPokemon.id).padStart(3, '0')}/151`
    : '000/151';
  const builderDisplayDamage = builderDamage.trim() || String(builderAutoDamage);
  const builderDisplayCardNumber = builderCardNumberInput.trim() || builderAutoCardNumber;

  // Cursor-tracked tilt + holo sheen for the live preview card
  const [builderTilt, setBuilderTilt] = useState({ rx: 0, ry: 0, mx: 50, my: 50, active: false });
  const handleBuilderCardMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width;
    const py = (e.clientY - rect.top) / rect.height;
    setBuilderTilt({ rx: (0.5 - py) * 16, ry: (px - 0.5) * 16, mx: px * 100, my: py * 100, active: true });
  };
  const handleBuilderCardMouseLeave = () => {
    setBuilderTilt({ rx: 0, ry: 0, mx: 50, my: 50, active: false });
  };

  useEffect(() => {
    if (!builderShowPokemonPicker) return;
    const handler = (e) => { if (!e.target.closest('[data-pokemon-picker]')) setBuilderShowPokemonPicker(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [builderShowPokemonPicker]);

  useEffect(() => {
    const interval = setInterval(() => {
      setDisplayImageIndex(i => (i + 1) % 5);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const switchTab = (tab) => {
    setActiveTab(tab);
    setSelectedSocialBar(null);
    window.location.hash = tab;
  };

  const [searchQuery, setSearchQuery] = useState('');
  const [showVideoModal, setShowVideoModal] = useState(false);
  const bannerBubbleRef = React.useRef(null);
  const [videoEnded, setVideoEnded] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [images, setImages] = useState([]);

  const [currentExampleIndex, setCurrentExampleIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  const examples = ['Pikachu', 'Giratina', 'Sunflora'];

  const categories = [
    { id: 'all', name: 'All Items', folder: null },
    { id: 'tcg', name: 'Pokemon TCG', folder: 'TCG' },
    { id: 'nontcg', name: 'Non-TCG', folder: 'nonTCG' },
  ];

  const handleDiscordLogin = () => {
    const CLIENT_ID = '1360587565190746193';
    const REDIRECT_URI = encodeURIComponent(window.location.origin);
    const SCOPE = encodeURIComponent('identify guilds');
    const AUTH_URL = `https://discord.com/api/oauth2/authorize?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=token&scope=${SCOPE}`;
    window.location.href = AUTH_URL;
  };

  const handleLogout = () => {
    localStorage.removeItem('discordUser');
    setDiscordUser(null);
    setShowUserMenu(false);
  };

  useEffect(() => {
    if (!showUserMenu) return;
    const handler = (e) => {
      if (!e.target.closest('[data-user-menu]')) setShowUserMenu(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showUserMenu]);

  const [showMobileMenu, setShowMobileMenu] = useState(false);
  useEffect(() => {
    if (!showMobileMenu) return;
    const handler = (e) => {
      if (!e.target.closest('[data-mobile-menu]')) setShowMobileMenu(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showMobileMenu]);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes('access_token')) {
      const params = new URLSearchParams(hash.replace('#', '?'));
      const token = params.get('access_token');
      window.history.replaceState({}, document.title, window.location.pathname);
      fetch('https://discord.com/api/users/@me', {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => res.json())
        .then(userData => {
          return fetch('https://discord.com/api/users/@me/guilds', {
            headers: { Authorization: `Bearer ${token}` }
          })
            .then(res => res.json())
            .then(guilds => {
              const isMember = guilds.some(g => g.id === '1466528743265931459');
              if (isMember) {
                localStorage.setItem('discordUser', JSON.stringify(userData));
                setDiscordUser(userData);
              } else {
                setLoginError(true);
              }
            });
        })
        .catch(err => console.error("Login failed:", err));
    }
  }, []);

  useEffect(() => {
    const liveRef = ref(database, 'isLive');
    const unsubscribe = onValue(liveRef, (snapshot) => setIsLive(snapshot.val() === true));
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const memberRef = ref(database, 'memberCount');
    const unsubscribe = onValue(memberRef, (snapshot) => {
      const value = snapshot.val();
      if (value !== null && value !== undefined) setMemberCount(value);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const voiceRef = ref(database, 'voiceCount');
    const unsubscribe = onValue(voiceRef, (snapshot) => setVoiceCount(snapshot.val() || 0));
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const igRef = ref(database, 'instagramCount');
    const unsubscribe = onValue(igRef, (snapshot) => {
      const value = snapshot.val();
      if (value !== null && value !== undefined) setInstagramCount(value);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const wnRef = ref(database, 'whatnotCount');
    const unsubscribe = onValue(wnRef, (snapshot) => {
      const value = snapshot.val();
      if (value !== null && value !== undefined) setWhatnotCount(value);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const bannerRef = ref(database, 'bannerText');
    const unsubscribe = onValue(bannerRef, (snapshot) => setBannerText(snapshot.val() || ''));
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const statusRef = ref(database, 'myStatus');
    const unsubscribe = onValue(statusRef, (snapshot) => {
      setMyStatus(snapshot.val() || '');
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const presenceRef = ref(database, 'myPresence');
    const unsubscribe = onValue(presenceRef, (snapshot) => {
      setMyPresence(snapshot.val() || null);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const badgesRef = ref(database, 'myBadges');
    const unsubscribe = onValue(badgesRef, (snapshot) => {
      setMyBadges(snapshot.val() || []);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const activityRef = ref(database, 'myActivity');
    const unsubscribe = onValue(activityRef, (snapshot) => {
      setMyActivity(snapshot.val() || null);
    });
    return () => unsubscribe();
  }, []);


  const [elapsed, setElapsed] = useState('');
  useEffect(() => {
    if (!myActivity?.startedAt) { setElapsed(''); return; }
    const tick = () => {
      const secs = Math.floor((Date.now() - myActivity.startedAt) / 1000);
      const h = Math.floor(secs / 3600);
      const m = Math.floor((secs % 3600) / 60);
      const sc = secs % 60;
      setElapsed(h > 0
        ? `${h}:${String(m).padStart(2,'0')}:${String(sc).padStart(2,'0')}`
        : `${m}:${String(sc).padStart(2,'0')}`);
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [myActivity?.startedAt]);

  const formatCount = (count) => {
    if (!count) return null;
    return count.toLocaleString();
  };

  useEffect(() => {
    // TCG Images
const tcgFileList = [
  'Articuno Holo - Fossil - Japanese.png',
  'Blissey Holo - Neo Revelation - Japanese.png',
  'Charizard EX SIR - Pokemon 151 - English.png',
  'Charizard Rainbow - Brilliant Stars - English.png',
  'Charizard Rev Holo - Premium File Promo - Japanese.png',
  'Dark Raichu Holo - Team Rocket WOTC - English.png',
  'Eevee EX Promo - Prismatic Evolutions UPC - English.png',
  'Eevee EX SAR - Terastal Festival - Japanese.png',
  'Entei Rev Holo - Premium File Promo - Japanese.png',
  'Felt Hat Pikachu - Promo - English.png',
  'Gengar VMAX Alt Art 1 - Fusion Strike - English.png',
  'Gengar VMAX Alt Art 2 - Fusion Strike - English.png',
  'Gengar VMAX Alt Art 3 - Fusion Strike - English.png',
  'Giratina V Alt Art - Lost Origin - English.png',
  'Haunter Holo - Fossil - Japanese.png',
  'Lugia Holo - Neo Genesis - Japanese.png',
  'Lugia V Alt Art - Silver Tempest - English.png',
  'Mega Charizard EX - Inferno X - Japanese.png',
  'Mega Charizard EX Promo 1 - Charizard UPC - English.png',
  'Mega Charizard EX Promo 2 - Charizard UPC - English.png',
  'Mega Charizard EX SIR - Phantasmal Flames - English.png',
  'Mew EX - Pokemon 151 - Japanese.png',
  'Mew Holo - WOTC Promo - English.png',
  'Moltres Holo - Fossil - Japanese.png',
  'Moltres V Alt Art - Chilling Reign - English.png',
  'Pichu Rev Holo - Premium File Promo - Japanese.png',
  'Rayquaza VMAX 1 - Silver Tempest - English.png',
  'Rayquaza VMAX 2 - Silver Tempest - English.png',
  'Spiky Eared Pichu Holo - Legend of Arceus Promo - Japanese.png',
  'Togepi Rev Holo - Southern Islands Promo - Japanese.png',
  'Umbreon VMAX Alt Art - Evolving Skies - English.png',
];

    // Non-TCG Images (plushies, figures, sealed products, etc.)
const nonTCGFileList = [
  'Batomen - Series 1 - TOMY.jpg',
  'Batomen - Series 2 - TOMY.jpg',
  'Batomen - Series 3 - TOMY.jpg',
  'Battle Memo - Part 1 - TOMY.jpg',
  'Battle Memo - Part 2 - TOMY.jpg',
  'Battle Memo - Part 3 - TOMY.jpg',
  'Blastoise  - Batomen - TOMY.jpg',
  'Charizard - Batomen - TOMY.jpg',
  'Charmander - Topsun Blue Back - Japanese.png',
  'Coonuts - Series 3 - Bandai.jpg',
  'Gengar Clear Promo - PokeMaze - Pokemon Center Japan.jpg',
  'Mew Holo - Batomen - TOMY.jpg',
  'Mewtwo Holo - Batomen - TOMY.jpg',
  'Pikachu - Pixel Coaster - Pokemon Center Japan.jpg',
  'Pikachu - Pokepeace - Plushy Notepad.jpg',
  'Pikachu & Eevee - PokeGET.jpg',
  'Snorlax - Bandai Anime - Carddass.jpg',
  'Umbreon Clear Promo - PokeMaze - Pokemon Center Japan.jpg',
  'Venusaur  - Batomen - TOMY.jpg',
  'Wilfried Zaha & Yannick Bolasie - Crystal Palace Dual Auto (9 of 10) - Topps Chrome Premier League 2026.png',
];

    const tcgImages = tcgFileList.map((filename, index) => {
      const nameWithoutExt = filename.replace(/\.[^/.]+$/, '');
      let parts = nameWithoutExt.split('-').map(p => p.trim()).filter(p => p);
      let gradeLabel = null;
      const gradingCompanies = ['PSA', 'BGS', 'ACE', 'CGC'];
      const firstPart = parts[0];
      const weightMatch = firstPart.match(/^(\d+\.?\d*g)\s+(.+)/i);
      if (weightMatch) {
        gradeLabel = weightMatch[1];
        parts[0] = weightMatch[2];
      } else {
        for (const company of gradingCompanies) {
          if (firstPart.toUpperCase().startsWith(company)) {
            const gradeMatch = firstPart.match(new RegExp(`${company}\\s*([0-9.]+)\\s*(.*)`, 'i'));
            if (gradeMatch) {
              gradeLabel = `${company} ${gradeMatch[1]}`;
              parts[0] = gradeMatch[2].trim();
              if (!parts[0]) parts.shift();
            }
            break;
          }
        }
      }
      const cardName = parts[0] || 'Unknown Card';
      const setLines = parts.slice(1);
      let serialLabel = null;
      const serialMatch = nameWithoutExt.match(/\((\d+)\s+of\s+(\d+)\)/i);
      if (serialMatch) {
        const num = String(parseInt(serialMatch[1])).padStart(2, '0');
        const total = String(parseInt(serialMatch[2])).padStart(2, '0');
        serialLabel = `${num} / ${total}`;
      }
      return { id: index + 1, name: cardName, set: setLines.join('  '), filename, category: 'tcg', grade: gradeLabel, serial: serialLabel, folder: 'TCG' };
    });

    const nonTCGImages = nonTCGFileList.map((filename, index) => {
      const nameWithoutExt = filename.replace(/\.[^/.]+$/, '');
      let parts = nameWithoutExt.split('-').map(p => p.trim()).filter(p => p);
      let gradeLabel = null;
      const firstPart = parts[0];
      const weightMatch = firstPart.match(/^(\d+\.?\d*g)\s+(.+)/i);
      if (weightMatch) {
        gradeLabel = weightMatch[1];
        parts[0] = weightMatch[2];
      }
      // Extract serial number e.g. (9 of 10) or (09 of 10) from any part
      let serialLabel = null;
      const fullName = nameWithoutExt;
      const serialMatch = fullName.match(/\((\d+)\s+of\s+(\d+)\)/i);
      if (serialMatch) {
        const num = String(parseInt(serialMatch[1])).padStart(2, '0');
        const total = String(parseInt(serialMatch[2])).padStart(2, '0');
        serialLabel = `${num} / ${total}`;
      }
      const itemName = parts[0] || 'Unknown Item';
      const itemLines = parts.slice(1);
      return { id: tcgImages.length + index + 1, name: itemName, set: itemLines.join('  '), filename, category: 'nontcg', grade: gradeLabel, serial: serialLabel, folder: 'nonTCG' };
    });

    setImages([...tcgImages, ...nonTCGImages]);
  }, []);

  useEffect(() => {
    const currentExample = examples[currentExampleIndex];
    if (isTyping) {
      if (currentText.length < currentExample.length) {
        const timeout = setTimeout(() => setCurrentText(currentExample.substring(0, currentText.length + 1)), 100);
        return () => clearTimeout(timeout);
      } else {
        const timeout = setTimeout(() => setIsTyping(false), 2000);
        return () => clearTimeout(timeout);
      }
    } else {
      if (currentText.length > 0) {
        const timeout = setTimeout(() => setCurrentText(currentText.substring(0, currentText.length - 1)), 50);
        return () => clearTimeout(timeout);
      } else {
        const timeout = setTimeout(() => {
          setCurrentExampleIndex((prevIndex) => (prevIndex + 1) % examples.length);
          setIsTyping(true);
        }, 500);
        return () => clearTimeout(timeout);
      }
    }
  }, [currentText, isTyping, currentExampleIndex]);

  useEffect(() => {
    const video = document.createElement('video');
    video.src = '/splash.mp4';
    video.preload = 'auto';
    video.load();
  }, []);

  // Prevent right-click / long-press saving of images
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      img { -webkit-user-select: none; user-select: none; -webkit-touch-callout: none; pointer-events: none; }
      a img, button img { pointer-events: auto; }
      * { -webkit-touch-callout: none; }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  // Live clock
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    if (activeTab !== 'profile') return;
    const container = bannerBubbleRef.current;
    if (!container) return;
    const bubbles = [];
    for (let i = 0; i < 22; i++) {
      const b = document.createElement('div');
      b.className = 'banner-bubble';
      const size = Math.random() * 20 + 12;
      b.style.width = `${size}px`;
      b.style.height = `${size}px`;
      b.style.left = `${Math.random() * 100}%`;
      b.style.animationDelay = `-${Math.random() * 8}s`;
      b.style.animationDuration = `${Math.random() * 4 + 5}s`;
      b.style.setProperty('--bdrift', Math.random() * 2 - 1);
      container.appendChild(b);
      bubbles.push(b);
    }
    return () => bubbles.forEach(b => b.remove());
  }, [activeTab]);

  const handleVideoEnd = () => setVideoEnded(true);
  const handleVideoModalClose = () => {
    setShowVideoModal(false);
    setVideoEnded(false);
  };

  const handleSearch = () => { /* filter is reactive */ };

  const filteredImages = images.filter(img => {
    if (!searchQuery) return selectedCategory === 'all' || img.category === selectedCategory;
    const searchWords = searchQuery.toLowerCase().trim().split(/\s+/);
    const searchableText = [img.name, img.set, img.filename, img.grade || ''].join(' ').toLowerCase();
    const matchesSearch = searchWords.every(word => searchableText.includes(word));
    const matchesCategory = selectedCategory === 'all' || img.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  // ── Profile link data ──────────────────────────────────────────────
  const profileLinks = [
    {
      label: 'Discord',
      sub: 'discord.cheeks.uk',
      href: 'https://pokebubble.com/docs',
      color: '#5865F2',
      bgColor: 'rgba(88,101,242,0.12)',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057c.001.022.015.043.032.054a19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03z"/>
        </svg>
      )
    },
    {
      label: 'Instagram',
      sub: '@togecheeks',
      href: 'https://www.instagram.com/togecheeks',
      color: '#E1306C',
      bgColor: 'rgba(225,48,108,0.12)',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
        </svg>
      )
    },
    {
      label: 'Whatnot — Live Auctions',
      sub: 'Watch & bid live',
      href: 'https://www.whatnot.com/user/togecheeks/shows',
      color: '#FADC00',
      bgColor: 'rgba(250,220,0,0.1)',
      isButton: true,
      icon: <Gift className="h-5 w-5" />
    },
    {
      label: 'Get £10 FREE on Whatnot',
      sub: 'New buyer promo',
      href: 'https://whatnot.com/invite/togecheeks',
      color: '#FADC00',
      bgColor: 'rgba(250,220,0,0.1)',
      icon: <DollarSign className="h-5 w-5" />
    },
    {
      label: 'Bookmark Next Livestreams',
      sub: 'Never miss a drop',
      href: 'https://www.whatnot.com/user/togecheeks/shows',
      color: '#FADC00',
      bgColor: 'rgba(250,220,0,0.1)',
      icon: <Bookmark className="h-5 w-5" />
    },
  ];

  const badgeMap = {
    diamond: { img: '/diamond.png', label: 'Diamond' },
  };

  const badges = (Array.isArray(myBadges) ? myBadges : Object.keys(myBadges || {}))
    .map(key => badgeMap[key])
    .filter(Boolean);

  return (
    <div
      className="bg-slate-900 flex flex-col"
      style={{ minHeight: '100svh' }}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
      onClick={(e) => { if (!e.target.closest('.social-bar-press')) setSelectedSocialBar(null); }}
    >
      <style>{"@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@500;600;700&family=Barlow+Condensed:wght@500;600;700&display=swap');"}</style>

      {/* ── BANNER ── */}
      {bannerText && (
        <div className="relative z-50 flex items-center justify-center py-2 px-4 bg-slate-800/80 backdrop-blur-lg border-b border-slate-700/50">
          <div className="flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full px-4 py-1.5 shadow-sm">
            <img src="/pball.svg" alt="" className="h-3 w-3 animate-spin flex-shrink-0" style={{animationDuration:'0.8s', filter:'brightness(0) invert(1)'}} />
            <span className="text-white text-[11px] font-medium tracking-wide leading-none">
              {(() => {
                const linkRegex = /\[(.*?)\]\((.*?)\)/;
                const match = bannerText.match(linkRegex);
                if (match) {
                  const [fullMatch, label, url] = match;
                  const [before, after] = bannerText.split(fullMatch);
                  return (
                    <>
                      {before}
                      <a href={url} onClick={url.startsWith('http://cheeks.uk/#') || url.startsWith('/#') ? (e) => { e.preventDefault(); const tab = url.split('#')[1]; if (['profile','inventory','creations'].includes(tab)) { switchTab(tab); } } : undefined} className="ml-1.5 bg-white/20 hover:bg-white/40 px-2 py-0.5 rounded-full text-[10px] transition-all border border-white/20 inline-flex items-center hover:scale-105 active:scale-95 font-semibold">
                        {label}
                      </a>
                      {after}
                    </>
                  );
                }
                return bannerText;
              })()}
            </span>
          </div>
        </div>
      )}

      {/* ── TOP NAV ── */}
      <div className="bg-slate-800/80 backdrop-blur-lg border-b border-slate-700/50 relative z-[100]">
        <div className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between">

            {/* Left: balance */}
            <div className="flex items-center flex-1">
            </div>

            {/* Centre: logo */}
            <div className="flex flex-col justify-center items-center gap-1">
              <div className="flex items-center gap-2.5">
                <img src="/cheeks_logo.svg" alt="Cheeks Logo" className="h-10 object-contain filter drop-shadow-md opacity-90" />
                <span className="text-slate-500 font-semibold" style={{ fontSize: '1.1rem' }}>×</span>
                <img src="/cheeky_cards.png" alt="Cheeky Cards" className="h-10 object-contain filter drop-shadow-md opacity-90" />
              </div>
              <style>{`
                @keyframes subtitlePulse {
                  0%   { color: #475569; }
                  50%  { color: #cbd5e1; }
                  100% { color: #475569; }
                }
                .header-subtitle { color: #475569; }
                .header-subtitle.shimmer-active {
                  animation: subtitlePulse 1.4s ease-in-out forwards;
                }
              `}</style>
              <p
                className="header-subtitle font-semibold uppercase text-center"
                style={{fontSize:'0.45rem', letterSpacing:'0.18em', lineHeight:1.5, fontFamily:"'Barlow Condensed', 'Arial Narrow', sans-serif", whiteSpace:'nowrap'}}
                ref={(el) => {
                  if (!el) return;
                  let active = false;
                  const run = () => {
                    el.classList.add('shimmer-active');
                    setTimeout(() => el.classList.remove('shimmer-active'), 1200);
                  };
                  if (!el._shimmerInit) {
                    el._shimmerInit = true;
                    setTimeout(run, 1500);
                    setInterval(run, 5000);
                  }
                }}
              >Trading Cards, Collectibles, Custom Accessories &amp; More</p>
            </div>

            {/* Right: login */}
            <div className="flex items-center justify-end flex-1">
              <div className="relative" data-user-menu>
                {!discordUser ? (
                  <div className="relative">
                    <button
                      onClick={handleDiscordLogin}
                      className="flex flex-col items-center justify-center text-white transition-all duration-200 active:scale-95 flex-shrink-0 bg-slate-700/50 hover:bg-slate-600/50 border border-slate-600"
                      style={{width:'36px', height:'36px', borderRadius:'50%'}}
                      title="Login"
                    >
                      <LogIn className="h-3 w-3 flex-shrink-0" />
                      <span className="text-white font-bold leading-none" style={{fontSize:'0.38rem', letterSpacing:'0.08em'}}>LOGIN</span>
                    </button>
                    {loginError && (
                      <div
                        className="absolute top-full right-0 mt-1.5 w-48 rounded-lg px-2.5 py-2 shadow-xl z-[999] transition-opacity duration-500"
                        style={{backgroundColor:'rgba(15,15,20,0.92)', border:'1px solid rgba(255,102,102,0.4)', opacity: loginErrorVisible ? 1 : 0}}
                      >
                        <p className="text-[10px] leading-snug" style={{color:'#FF6666'}}>You must be a member of PokéBubble to login.</p>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="relative" data-user-menu>
                    <button
                      onClick={() => setShowUserMenu(prev => !prev)}
                      className="flex flex-col items-center justify-center text-white transition-all duration-200 active:scale-95 flex-shrink-0 bg-slate-700/50 hover:bg-slate-600/50 border border-slate-600"
                      style={{width:'44px', minHeight:'36px', borderRadius:'10px', padding:'4px 2px'}}
                    >
                      <img
                        src={`https://cdn.discordapp.com/avatars/${discordUser.id}/${discordUser.avatar}.png`}
                        alt="User"
                        className="h-4 w-4 rounded-full flex-shrink-0"
                      />
                      <span className="font-bold leading-none truncate" style={{fontSize:'0.38rem', letterSpacing:'0.02em', maxWidth:'40px'}}>{discordUser.username}</span>
                    </button>
                    {showUserMenu && (
                      <div className="absolute right-0 top-full mt-1 bg-slate-800 border border-slate-700 rounded-lg shadow-xl z-[999] min-w-[120px]">
                        <div className="px-3 py-2 border-b border-slate-700">
                          <p className="text-white text-xs font-semibold truncate">{discordUser.username}</p>
                          <p className="text-slate-400 text-[10px]">Discord</p>
                        </div>
                        <button
                          onClick={handleLogout}
                          className="w-full text-left px-3 py-2 text-red-400 hover:bg-slate-700/50 text-xs font-medium transition-colors rounded-b-lg flex items-center space-x-2"
                        >
                          <LogIn className="h-3 w-3 rotate-180" />
                          <span>Log out</span>
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ── TAB BAR ── */}
      <div className="bg-slate-900/95 backdrop-blur-lg sticky top-0 z-30 border-b border-slate-700/30">
        <div className="max-w-7xl mx-auto px-3">
          <div className="flex items-center justify-between py-1.5">

            {/* Left group: nav controls (desktop pills, hidden on mobile) + shipping badge */}
            <div className="flex items-center gap-3 min-w-0">
            <div className="hidden md:flex items-center gap-1">
              {TAB_LIST.map(({ id, label, path }) => {
                const isActive = activeTab === id;
                return (
                  <button
                    key={id}
                    onClick={() => switchTab(id)}
                    className="flex items-center gap-1 rounded-lg font-semibold transition-all duration-200"
                    style={{
                      padding: isActive ? '5px 8px' : '5px 6px',
                      fontSize: '0.6rem',
                      ...(isActive ? {
                        background: 'linear-gradient(135deg, #22d3ee, #3b82f6)',
                        color: 'white',
                        boxShadow: '0 2px 12px rgba(34,211,238,0.25)',
                      } : {
                        color: 'rgba(148,163,184,0.5)',
                        background: 'transparent',
                      })
                    }}
                  >
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      {path}
                    </svg>
                    <span>{label}</span>
                  </button>
                );
              })}
            </div>
            </div>

            {/* Hamburger menu — mobile only, pinned to the right */}
            <div className="relative md:hidden" data-mobile-menu>
              <button
                onClick={() => setShowMobileMenu(v => !v)}
                className="flex items-center justify-center rounded-lg transition-all duration-200"
                style={{
                  width: '32px',
                  height: '32px',
                  background: showMobileMenu ? 'linear-gradient(135deg, #22d3ee, #3b82f6)' : 'transparent',
                  color: showMobileMenu ? 'white' : 'rgba(203,213,225,0.85)',
                }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </svg>
              </button>
              {showMobileMenu && (
                <div className="absolute right-0 top-full mt-2 w-44 bg-slate-800 border border-slate-700 rounded-xl shadow-xl z-50 overflow-hidden py-1">
                  {TAB_LIST.map(({ id, label, path }) => {
                    const isActive = activeTab === id;
                    return (
                      <button
                        key={id}
                        onClick={() => { switchTab(id); setShowMobileMenu(false); }}
                        className="w-full flex items-center gap-2.5 px-3.5 py-2.5 text-left transition-colors duration-150"
                        style={{
                          background: isActive ? 'linear-gradient(135deg, #22d3ee, #3b82f6)' : 'transparent',
                          color: isActive ? 'white' : 'rgba(203,213,225,0.85)',
                        }}
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0">
                          {path}
                        </svg>
                        <span className="text-xs font-semibold">{label}</span>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>

          </div>
        </div>

        {/* Search bar — only shown in inventory, part of same sticky block */}
        {activeTab === 'inventory' && (
          <div className="bg-slate-900 border-b border-slate-700/50">
            <div className="max-w-7xl mx-auto px-4 py-3">
              <div className="flex items-center gap-2">
                <div className="relative flex-1">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 h-4 w-4" />
                  <input
                    type="text"
                    placeholder={`Search… ${currentText}|`}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                    className="pl-9 pr-3 py-2.5 bg-slate-700/50 border border-slate-600 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent w-full text-white placeholder-slate-500 text-sm transition-all duration-200"
                  />
                  {searchQuery && (
                    <button
                      onClick={() => setSearchQuery('')}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white"
                    >
                      <X className="h-4 w-4" />
                    </button>
                  )}
                </div>
                <button
                  onClick={handleSearch}
                  className="bg-gradient-to-r from-cyan-500 to-blue-600 text-white p-2.5 rounded-xl transition-all duration-200 active:scale-95 flex-shrink-0"
                >
                  <Search className="h-4 w-4" />
                </button>
              </div>

              {/* Category pills */}
              <div className="flex gap-2 mt-2.5 overflow-x-auto pb-0.5 scrollbar-hide">
                {categories.map(cat => (
                  <button
                    key={cat.id}
                    onClick={() => setSelectedCategory(cat.id)}
                    className={`px-3.5 py-1.5 rounded-xl font-medium transition-all duration-200 text-xs whitespace-nowrap flex-shrink-0 ${
                      selectedCategory === cat.id
                        ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-lg'
                        : 'bg-slate-700/50 text-slate-400 hover:text-white border border-slate-700/50'
                    }`}
                  >
                    {cat.name}
                    {cat.id !== 'all' && (
                      <span className="ml-1 opacity-70">({images.filter(img => img.category === cat.id).length})</span>
                    )}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* ══════════════════════════════════════════
          PROFILE TAB
      ══════════════════════════════════════════ */}
      {activeTab === 'profile' && (
        <main className="flex-1">
          <style>{`
            @keyframes profileFadeUp {
              from { opacity: 0; transform: translateY(18px); }
              to   { opacity: 1; transform: translateY(0); }
            }
            .profile-panel {
              animation: profileFadeUp 0.45s ease both;
            }
          `}</style>
          <div className="profile-panel max-w-2xl mx-auto px-4 py-6 flex flex-col gap-4">

            {/* Avatar + name card */}
            <div className="bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] overflow-hidden">
              {/* Banner strip */}
              <div
                className="h-36 relative overflow-hidden"
                style={{ background: '#0c1a35' }}
              >
                <style>{`
                  @keyframes bannerShift {
                    0%   { background-position: 0% 50%; }
                    50%  { background-position: 100% 50%; }
                    100% { background-position: 0% 50%; }
                  }
                  .banner-anim {
                    position: absolute;
                    inset: 0;
                    background-image: url('/togebanner.png');
                    background-size: cover;
                    background-position: center;
                  }
                  .banner-tint {
                    position: absolute;
                    inset: 0;
                    background: linear-gradient(160deg, rgba(12,26,53,0.72) 0%, rgba(10,58,92,0.65) 50%, rgba(13,42,74,0.72) 100%);
                  }
                  .banner-tint::after {
                    content: none;
                  }
                  @keyframes bannerBubbleFloat {
                    0%   { transform: translateY(0) translateX(0); opacity: 0; }
                    10%  { opacity: 0.7; }
                    80%  { opacity: 0.7; }
                    100% { transform: translateY(-200px) translateX(calc(8px * var(--bdrift))); opacity: 0; }
                  }
                  .banner-bubble {
                    position: absolute;
                    bottom: -20px;
                    border-radius: 50%;
                    background: radial-gradient(circle at 50% 50%,
                      rgba(255,255,255,0.04) 0%,
                      rgba(255,255,255,0.12) 60%,
                      rgba(255,255,255,0.35) 100%);
                    box-shadow:
                      inset 0 0 6px rgba(255,255,255,0.3),
                      inset 3px 0 6px rgba(180,100,255,0.25),
                      inset -3px 0 6px rgba(100,180,255,0.25),
                      inset 0 -3px 6px rgba(255,120,180,0.2);
                    mask-image: radial-gradient(circle, white 68%, transparent 71%);
                    -webkit-mask-image: radial-gradient(circle, white 68%, transparent 71%);
                    animation: bannerBubbleFloat linear infinite;
                    pointer-events: none;
                  }
                  .banner-bubble::after {
                    content: '';
                    position: absolute;
                    top: 18%;
                    left: 18%;
                    width: 22%;
                    height: 14%;
                    background: rgba(255,255,255,0.5);
                    border-radius: 50%;
                    transform: rotate(-35deg);
                    filter: blur(1px);
                  }
                `}</style>
                <div className="banner-anim" />
                <div className="banner-tint" />
                {/* Bubbles injected via ref */}
                <div ref={bannerBubbleRef} style={{position:'absolute',inset:0,pointerEvents:'none'}} />
                {/* Location + time */}
                <div style={{position:'absolute', top:'8px', right:'8px', display:'flex', alignItems:'center', pointerEvents:'none'}}>
                  <div style={{
                    display:'flex', alignItems:'center', gap:'4px',
                    background:'rgba(15,23,42,0.75)',
                    backdropFilter:'blur(6px)',
                    paddingLeft:'8px', paddingRight:'8px', paddingTop:'4px', paddingBottom:'4px',
                    borderRadius:'999px',
                    border:'1px solid rgba(51,65,85,0.5)',
                  }}>
                    <img src="https://flagcdn.com/gb.svg" alt="UK" style={{width:'12px',height:'12px',borderRadius:'50%',objectFit:'cover',flexShrink:0}} />
                    <span style={{color:'rgba(255,255,255,0.5)', fontSize:'0.55rem', fontWeight:500, letterSpacing:'0.02em', lineHeight:1, display:'block', paddingTop:'1px'}}>
                      London &nbsp;·&nbsp; {currentTime.toLocaleDateString('en-GB', {day:'numeric',month:'short',year:'numeric'})} &nbsp;{currentTime.toLocaleTimeString('en-GB', {hour:'2-digit',minute:'2-digit',second:'2-digit'})}
                    </span>
                  </div>
                </div>
              </div>

              <div className="px-4 pb-4 relative" style={{borderTop: '1px solid rgba(51,65,85,0.5)'}}>
                {/* Activity info — top-right, sits flush under the banner */}
                {myActivity && (
                  <div style={{position:'absolute', top:'0', right:'0', background:'rgb(30,41,59)', borderLeft:'1px solid rgba(51,65,85,0.5)', borderBottom:'1px solid rgba(51,65,85,0.5)', borderBottomLeftRadius:'12px', padding:'6px 10px', display:'flex', flexDirection:'column', gap:'1px', lineHeight:'1.2', whiteSpace:'nowrap', alignItems:'flex-end', zIndex:10}}>
                    <div className="text-slate-400 text-[9px] font-semibold uppercase tracking-wider">{myActivity.type}</div>
                    <div className="text-slate-400 text-[9px] font-medium">{myActivity.name}</div>
                    {myActivity.detail && <div className="text-slate-500 text-[9px]">{myActivity.detail}</div>}
                    {myActivity.state && <div className="text-slate-500 text-[9px]">{myActivity.state}</div>}
                    {elapsed && <div style={{display:'flex', alignItems:'center', gap:'2px', color:'#23a55a', fontSize:'0.6rem', fontWeight:500, lineHeight:1, marginTop:'2px'}}>
                      {myActivity.type === 'Watching' && <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#23a55a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>}
                      {myActivity.type === 'Playing' && <img src="/controller.svg" width="9" height="9" style={{flexShrink:0, filter:'brightness(0) saturate(100%) invert(52%) sepia(98%) saturate(346%) hue-rotate(95deg) brightness(93%) contrast(92%)'}} />}
                      {myActivity.type === 'Listening' && <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#23a55a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>}
                      {myActivity.type === 'Streaming' && <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#23a55a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>}
                      {!['Watching','Playing','Listening','Streaming'].includes(myActivity.type) && <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#23a55a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>}
                      {elapsed}
                    </div>}
                  </div>
                )}
                {/* Avatar row */}
                <div className="flex items-start" style={{ marginTop: -36 }}>

                  {/* Avatar — left, relative so activity text can be absolute */}
                  <div className="relative flex-shrink-0">
                    {/* Floating hearts on load */}
                    <style>{`
                      @keyframes heartFloat {
                        0%   { transform: translateY(0) scale(0.6) rotate(var(--hr)); opacity: 0; }
                        15%  { opacity: 1; transform: translateY(-10px) scale(1) rotate(var(--hr)); }
                        80%  { opacity: 0.8; }
                        100% { transform: translateY(-70px) translateX(var(--hx)) scale(0.7) rotate(var(--hr)); opacity: 0; }
                      }
                      .pfp-heart {
                        position: absolute;
                        pointer-events: none;
                        animation: heartFloat 1.4s ease-out forwards;
                        font-size: 14px;
                        filter: drop-shadow(0 0 3px rgba(251,113,133,0.6));
                      }
                    `}</style>
                    {showHearts && [
                      { delay: '0s',    left: '30%', hx: '-8px',  hr: '-15deg', size: '13px' },
                      { delay: '0.15s', left: '55%', hx: '6px',   hr: '10deg',  size: '10px' },
                      { delay: '0.3s',  left: '20%', hx: '-4px',  hr: '-8deg',  size: '16px' },
                      { delay: '0.45s', left: '70%', hx: '10px',  hr: '20deg',  size: '11px' },
                      { delay: '0.6s',  left: '45%', hx: '-2px',  hr: '-5deg',  size: '14px' },
                      { delay: '0.1s',  left: '80%', hx: '5px',   hr: '12deg',  size: '9px'  },
                    ].map((h, i) => (
                      <span
                        key={i}
                        className="pfp-heart"
                        style={{
                          bottom: '10px',
                          left: h.left,
                          animationDelay: h.delay,
                          fontSize: h.size,
                          '--hx': h.hx,
                          '--hr': h.hr,
                        }}
                      >💗</span>
                    ))}
                    {/* Thought bubble */}
                    {myStatus && (
                      <div style={{position: 'absolute', top: '-8px', left: '75px', pointerEvents: 'none'}}>
                        <div style={{background: '#1e293b', border: '1px solid rgba(51,65,85,0.5)', borderRadius: '12px', padding: '4px 10px', whiteSpace: 'nowrap', marginLeft: '14px', lineHeight: 1, display: 'inline-flex', alignItems: 'center'}}>
                          <span style={{color: '#cbd5e1', fontSize: '0.6rem', fontWeight: 500, display: 'block'}}>{myStatus}</span>
                        </div>
                        <div style={{width: '8px', height: '8px', borderRadius: '50%', background: '#1e293b', border: '1px solid rgba(51,65,85,0.5)', marginTop: '3px', marginLeft: '8px'}}></div>
                      </div>
                    )}
                    <div className="w-20 h-20 rounded-full overflow-hidden bg-slate-800 flex items-center justify-center shadow-xl" style={{border: '1px solid rgba(51,65,85,0.5)'}}>
                      <img src="/pfp.png" alt="Profile" className="w-full h-full object-cover" />
                    </div>
                    {/* Presence status dot */}
                    {(() => {
                      const s = myPresence || 'offline';
                      const dotColor = s === 'online' ? '#23a55a' : s === 'idle' ? '#f0b232' : s === 'dnd' ? '#f23f43' : '#80848e';
                      if (s === 'idle') return (
                        <svg
                          className="absolute bottom-0.5 right-0.5"
                          width="20" height="20" viewBox="0 0 20 20"
                          title="Idle"
                        >
                          <circle cx="10" cy="10" r="10" fill="#1e293b"/>
                          <circle cx="10" cy="10" r="6.5" fill="#f0b232"/>
                          <circle cx="7.5" cy="7.5" r="5" fill="#1e293b"/>
                        </svg>
                      );
                      return (
                        <div
                          className="absolute bottom-0.5 right-0.5 w-5 h-5 rounded-full flex items-center justify-center"
                          style={{ background: dotColor, border: '3.5px solid #1e293b' }}
                          title={s === 'dnd' ? 'Do Not Disturb' : s.charAt(0).toUpperCase() + s.slice(1)}
                        >
                          {s === 'dnd' && <div style={{width:'55%',height:'2px',background:'white',borderRadius:2}} />}
                        </div>
                      );
                    })()}
                  </div>



                  {/* Badge row — sits to the right of the avatar, aligned to its bottom */}
                  <div className="flex items-end gap-1.5 ml-3 pb-0.5" style={{marginTop: 'auto'}}>
                    {badges.map((badge) => (
                      <div
                        key={badge.key}
                        title={badge.label}
                        className="w-8 h-8 rounded-lg bg-slate-800 flex items-center justify-center shadow-xl overflow-hidden"
                        style={{border: '1px solid rgba(51,65,85,0.5)'}}
                      >
                        <img src={badge.img} alt={badge.label} className="w-6 h-6 object-contain" />
                      </div>
                    ))}
                  </div>

                </div>

                {/* Name + bio */}
                <div className="mt-3">
                  <div className="flex items-center gap-1.5">
                    <h1 className="text-white font-bold text-xl leading-tight">cheeks</h1>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="flex-shrink-0 mt-0.5">
                      <defs>
                        <linearGradient id="checkGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                          <stop offset="0%" stopColor="#22d3ee"/>
                          <stop offset="100%" stopColor="#3b82f6"/>
                        </linearGradient>
                      </defs>
                      <circle cx="12" cy="12" r="10" fill="url(#checkGrad)"/>
                      <path d="M7.5 12.5l3 3 6-6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <p className="text-xs font-medium mt-0.5 mb-2" style={{ background: 'linear-gradient(135deg, #22d3ee, #3b82f6)', WebkitBackgroundClip: 'text', backgroundClip: 'text', WebkitTextFillColor: 'transparent', color: 'transparent' }}>@togecheeks</p>
                  <p className="text-slate-300 leading-relaxed" style={{fontSize: 'clamp(0.55rem, 2vw, 0.65rem)'}}>
                    Trading Cards, Collectibles, Custom Accessories & More ✨
                  </p>
                </div>

              </div>
            </div>

            {/* Social Links */}
            <div className="flex flex-col gap-2.5" onClick={(e) => { if (e.target === e.currentTarget) setSelectedSocialBar(null); }}>
              <style>{`
                @keyframes accentSweep {
                  0%   { clip-path: inset(0 100% 0 0 round 1rem); opacity: 0.6; }
                  100% { clip-path: inset(0 0% 0 0 round 1rem);   opacity: 1; }
                }
                @keyframes accentFadeOut {
                  0%   { opacity: 1; }
                  100% { opacity: 0; }
                }
                .accent-overlay-on  { animation: accentSweep 0.35s cubic-bezier(0.22,1,0.36,1) forwards; }
                .accent-overlay-off { animation: accentFadeOut 0.2s ease-out forwards; }
                @keyframes noticePulse {
                  0%   { box-shadow: 0 0 0 0 rgba(220,38,38,0.7), 0 4px 14px rgba(0,0,0,0.4); }
                  70%  { box-shadow: 0 0 0 10px rgba(220,38,38,0), 0 4px 14px rgba(0,0,0,0.4); }
                  100% { box-shadow: 0 0 0 0 rgba(220,38,38,0), 0 4px 14px rgba(0,0,0,0.4); }
                }
                .notice-pulse { animation: noticePulse 1.8s ease-out infinite; }
                @keyframes noticeIconPulse {
                  0%, 100% { transform: scale(1); }
                  50%      { transform: scale(1.18); }
                }
                .notice-icon-pulse { animation: noticeIconPulse 1.4s ease-in-out infinite; transform-origin: center; }
              `}</style>

              {/* Whatnot */}
              {isLive && (
                <style>{`
                  @keyframes liveGlow {
                    0%, 100% { box-shadow: 0 0 0 0 rgba(239,68,68,0), 0 6px 24px rgba(0,0,0,0.4); border-color: rgba(239,68,68,0.7); }
                    50%      { box-shadow: 0 0 18px 4px rgba(239,68,68,0.35), 0 6px 24px rgba(0,0,0,0.4); border-color: rgba(239,68,68,1); }
                  }
                  .whatnot-live { animation: liveGlow 1.8s ease-in-out infinite; }
                `}</style>
              )}
              <div className="relative">
              <button onClick={() => { setSelectedSocialBar(selectedSocialBar === 'whatnot' ? null : 'whatnot'); if (isLive) { window.location.href = 'whatnot://user/togecheeks/shows'; setTimeout(() => { window.open('https://www.whatnot.com/en-GB/user/togecheeks/shows', '_blank'); }, 1000); } else { setShowVideoModal(true); } }} className={`social-bar-press relative z-10 w-full flex items-center gap-3 bg-slate-800/60 backdrop-blur-sm rounded-2xl px-4 py-2.5 active:scale-[0.98] transition-all duration-200 ${isLive ? 'whatnot-live border-2 border-red-500/70' : 'border border-slate-700/50 shadow-[0_6px_24px_rgba(0,0,0,0.4)]'}`}>
                <div className={`absolute inset-0 rounded-2xl pointer-events-none ${selectedSocialBar === 'whatnot' ? 'accent-overlay-on' : 'accent-overlay-off'}`} style={{background: isLive ? 'rgba(239,68,68,0.18)' : 'rgba(250,220,0,0.12)'}} />
                <div className="absolute left-0 top-3 bottom-3 w-[3px] rounded-r-full flex-shrink-0" style={{background: isLive ? '#ef4444' : '#FADC00'}} />
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <div className="relative">
                    <img src="/wnlogo.png" alt="Whatnot" className="w-7 h-7 object-contain" />
                    {isLive && (
                      <span className="absolute -top-1 -right-1 flex h-2.5 w-2.5"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span><span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500 border-2 border-slate-800"></span></span>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-3 min-w-0 flex-1 pr-16 md:pr-24">
                  <div className="text-white font-semibold leading-none text-left uppercase tracking-widest text-[0.65rem] md:text-[0.82rem] flex-shrink-0" style={{fontFamily:"'Outfit', 'Inter', sans-serif", letterSpacing:'0.12em'}}>Whatnot</div>
                  {/* Shipping status pill — single thin line, flex-1 so it fills the available space */}
                  <div className="flex items-center gap-1.5 bg-slate-900/60 border border-slate-700/50 rounded-full px-3 py-1 flex-1 min-w-0">
                    <Package className="h-2.5 w-2.5 flex-shrink-0" style={{color:'#23a55a'}} />
                    <span className="text-slate-400 font-semibold uppercase whitespace-nowrap flex-shrink-0 hidden sm:inline" style={{fontSize:'0.6rem', letterSpacing:'0.06em'}}>Last Stream Orders</span>
                    <div className="relative rounded-full overflow-hidden bg-slate-700 flex-1" style={{minWidth:'20px', height:'5px'}}>
                      <div className="absolute inset-0" style={{background:'repeating-linear-gradient(45deg, #23a55a 0px, #23a55a 4px, #1c8a4c 4px, #1c8a4c 8px)'}} />
                    </div>
                    <span className="text-slate-400 font-medium whitespace-nowrap flex-shrink-0" style={{fontSize:'0.6rem'}}>100% Shipped</span>
                    <Check className="h-2.5 w-2.5 flex-shrink-0" style={{color:'#23a55a'}} />
                  </div>
                </div>
                <div className="absolute right-3 top-0 bottom-0 flex flex-col justify-between items-end py-2">
                  <div className="flex items-center gap-0.5 text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>
                    <Users className="h-2 w-2 flex-shrink-0" />
                    {whatnotCount !== null ? formatCount(whatnotCount) : '—'}
                  </div>
                  {isLive ? (
                    <div className="flex items-center gap-1 text-red-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>
                      <span className="relative flex h-1.5 w-1.5 flex-shrink-0"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75"></span><span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-red-500"></span></span>
                      LIVE NOW
                    </div>
                  ) : (
                    <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>Offline</span>
                  )}
                  <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>@togecheeks</span>
                </div>
              </button>
              {/* Packing delay notice — red tab attached just below the card */}
              <div className="relative z-0 mx-5" style={{ marginTop: '0px' }}>
                <div className="notice-pulse rounded-b-xl px-3 pt-1.5 pb-1.5 flex items-center gap-2.5" style={{ background: '#dc2626' }}>
                  <svg className="notice-icon-pulse flex-shrink-0" width="24" height="24" viewBox="0 0 24 24">
                    <circle cx="12" cy="12" r="11" fill="#FADC00" />
                    <rect x="10.7" y="6" width="2.6" height="8" rx="1.3" fill="#000000" />
                    <circle cx="12" cy="17" r="1.5" fill="#000000" />
                  </svg>
                  <p className="text-white leading-snug font-semibold flex-1" style={{ fontSize: 'clamp(0.56rem, 1.4vw, 0.64rem)' }}>
                    I have hired new streaming and packing staff. We experienced delays in postage while switching to a new system but all orders are now fulfilled — thank you for your patience and support with your purchases as always!
                  </p>
                </div>
              </div>
              </div>

              {/* Discord */}
              <a href="https://pokebubble.com/docs" onClick={() => setSelectedSocialBar(selectedSocialBar === 'discord' ? null : 'discord')} className="social-bar-press relative flex items-center gap-3 bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] px-4 py-2.5 active:scale-[0.98] transition-all duration-200">
                  <div className={`absolute inset-0 rounded-2xl pointer-events-none ${selectedSocialBar === 'discord' ? 'accent-overlay-on' : 'accent-overlay-off'}`} style={{background:'rgba(88,101,242,0.18)'}} />
                  <div className="absolute left-0 top-3 bottom-3 w-[3px] rounded-r-full flex-shrink-0" style={{background:'#5865F2'}} />
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <div className="relative">
                      <img src="/discord.png" alt="Discord" className="w-7 h-7 object-contain" />
                      {voiceCount > 0 && (
                        <div className="absolute -top-1 -right-2 text-white px-1 py-0.5 rounded-full flex items-center gap-0.5 shadow-sm" style={{backgroundColor:'#23a55a', border:'1px solid #1e293b'}}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-2 h-2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>
                          <span className="font-medium leading-none" style={{fontSize:'0.5rem'}}>{voiceCount}</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="text-white font-semibold leading-none uppercase tracking-widest text-[0.65rem] md:text-[0.82rem]" style={{fontFamily:"'Outfit', 'Inter', sans-serif", letterSpacing:'0.12em'}}>Discord</div>
                  <div className="absolute right-3 top-0 bottom-0 flex flex-col justify-between items-end py-2">
                    <div className="flex items-center gap-0.5 text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>
                      <Users className="h-2 w-2 flex-shrink-0" />
                      {memberCount !== null ? formatCount(memberCount) : '—'}
                    </div>
                    {voiceCount > 0 ? (
                      <div className="flex items-center gap-0.5 font-medium" style={{fontSize:'0.6rem', lineHeight:1, color:'#23a55a'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="8" height="8"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>
                        {voiceCount} in voice
                      </div>
                    ) : (
                      <div className="flex items-center gap-0.5 font-medium" style={{fontSize:'0.6rem', lineHeight:1, color:'#64748b'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="8" height="8"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>
                        0 in voice
                      </div>
                    )}
                    <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>discord.cheeks.uk</span>
                  </div>
                </a>

              {/* Instagram */}
              <a href="https://www.instagram.com/togecheeks" target="_blank" rel="noopener noreferrer" onClick={() => setSelectedSocialBar(selectedSocialBar === 'instagram' ? null : 'instagram')} className="social-bar-press relative flex items-center gap-3 bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] px-4 py-2.5 active:scale-[0.98] transition-all duration-200">
                <div className={`absolute inset-0 rounded-2xl pointer-events-none ${selectedSocialBar === 'instagram' ? 'accent-overlay-on' : 'accent-overlay-off'}`} style={{background:'rgba(225,48,108,0.18)'}} />
                <div className="absolute left-0 top-3 bottom-3 w-[3px] rounded-r-full flex-shrink-0" style={{background:'#E1306C'}} />
                <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0">
                  <img src="/instagram.png" alt="Instagram" className="w-7 h-7 object-contain" />
                </div>
                <div className="text-white font-semibold leading-none uppercase tracking-widest text-[0.65rem] md:text-[0.82rem]" style={{fontFamily:"'Outfit', 'Inter', sans-serif", letterSpacing:'0.12em'}}>Instagram</div>
                <div className="absolute right-3 top-0 bottom-0 flex flex-col justify-between items-end py-2">
                  <div className="flex items-center gap-0.5 text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>
                    <Users className="h-2 w-2 flex-shrink-0" />
                    {instagramCount !== null ? formatCount(instagramCount) : '—'}
                  </div>
                  <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>&nbsp;</span>
                  <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>@togecheeks</span>
                </div>
              </a>

              {/* eBay */}
              <div onClick={() => setSelectedSocialBar(selectedSocialBar === 'ebay' ? null : 'ebay')} className="social-bar-press relative flex items-center gap-3 bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] px-4 py-2.5 cursor-pointer transition-all duration-200">
                <div className={`absolute inset-0 rounded-2xl pointer-events-none ${selectedSocialBar === 'ebay' ? 'accent-overlay-on' : 'accent-overlay-off'}`} style={{background:'rgba(229,50,56,0.18)'}} />
                <div className="absolute left-0 top-3 bottom-3 w-[3px] rounded-r-full flex-shrink-0" style={{background:'#E53238'}} />
                <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0">
                  <img src="/ebay.png" alt="eBay" className="w-7 h-7 object-contain" />
                </div>
                <div className="text-white font-semibold leading-none uppercase tracking-widest text-[0.65rem] md:text-[0.82rem]" style={{fontFamily:"'Outfit', 'Inter', sans-serif", letterSpacing:'0.12em'}}>eBay</div>
                <div className="absolute right-3 top-0 bottom-0 flex flex-col justify-between items-end py-2">
                  <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>&nbsp;</span>
                  <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>&nbsp;</span>
                  <span className="text-slate-500 font-medium flex items-center gap-0.5" style={{fontSize:'0.6rem', lineHeight:1}}>
                    <svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                    100% (256)
                  </span>
                </div>
              </div>

              {/* MakerWorld */}
              <a href="https://makerworld.com/en/@togecheeks/upload" target="_blank" rel="noopener noreferrer" onClick={() => setSelectedSocialBar(selectedSocialBar === 'makerworld' ? null : 'makerworld')} className="social-bar-press relative flex items-center gap-3 bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] px-4 py-2.5 active:scale-[0.98] transition-all duration-200">
                <div className={`absolute inset-0 rounded-2xl pointer-events-none ${selectedSocialBar === 'makerworld' ? 'accent-overlay-on' : 'accent-overlay-off'}`} style={{background:'rgba(29,185,84,0.18)'}} />
                <div className="absolute left-0 top-3 bottom-3 w-[3px] rounded-r-full flex-shrink-0" style={{background:'#1DB954'}} />
                <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0">
                  <div className="w-6 h-6 rounded-full bg-white flex items-center justify-center">
                    <img src="/makerworld.png" alt="MakerWorld" className="w-5 h-5 object-contain" />
                  </div>
                </div>
                <div className="text-white font-semibold leading-none uppercase tracking-widest text-[0.65rem] md:text-[0.82rem]" style={{fontFamily:"'Outfit', 'Inter', sans-serif", letterSpacing:'0.12em'}}>MakerWorld</div>
                <div className="absolute right-3 top-0 bottom-0 flex flex-col justify-between items-end py-2">
                  <span className="text-slate-500 font-medium flex items-center gap-0.5" style={{fontSize:'0.6rem', lineHeight:1}}>
                    <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                    3.7M
                  </span>
                  <span className="text-slate-500 font-medium flex items-center gap-0.5" style={{fontSize:'0.6rem', lineHeight:1}}>
                    <svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><path d="M2 20h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1H2v11zm19.83-7.12c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66-.23-.45-.52-.86-.88-1.22L14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83V19c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.12z"/></svg>
                    3.2k
                  </span>
                  <span className="text-slate-500 font-medium flex items-center gap-0.5" style={{fontSize:'0.6rem', lineHeight:1}}>
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M19 9h-4V3H9v6H5l7 7 7-7zm-14 9v2h14v-2H5z"/></svg>
                    2.9k
                  </span>
                </div>
              </a>

              {/* Pokémon GO */}
              <div className="social-bar-press relative flex items-center gap-3 bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] px-4 py-2.5 cursor-pointer active:scale-[0.98] transition-all duration-200" onClick={() => { setSelectedSocialBar(selectedSocialBar === 'pogo' ? null : 'pogo'); navigator.clipboard?.writeText('664463929998'); setShowPogoModal(true); setShowCopiedToast(true); setTimeout(() => setShowCopiedToast(false), 2500); }}>
                <div className={`absolute inset-0 rounded-2xl pointer-events-none ${selectedSocialBar === 'pogo' ? 'accent-overlay-on' : 'accent-overlay-off'}`} style={{background:'rgba(3,12,166,0.25)'}} />
                <div className="absolute left-0 top-3 bottom-3 w-[3px] rounded-r-full flex-shrink-0" style={{background:'#030CA6'}} />
                <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0">
                  <img src="/pogo.png" alt="Pokémon GO" className="w-7 h-7 object-contain" />
                </div>
                <div className="text-white font-semibold leading-none uppercase tracking-widest text-[0.65rem] md:text-[0.82rem]" style={{fontFamily:"'Outfit', 'Inter', sans-serif", letterSpacing:'0.12em'}}>Pokémon GO</div>
                <div className="absolute right-3 top-0 bottom-0 flex flex-col justify-between items-end py-2">
                  <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>Lv. 71</span>
                  <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>Valor</span>
                  <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>togecheeks</span>
                </div>
              </div>

              {/* Steam */}
              <a href="https://steamcommunity.com/id/togecheeks/" target="_blank" rel="noopener noreferrer" onClick={() => setSelectedSocialBar(selectedSocialBar === 'steam' ? null : 'steam')} className="social-bar-press relative flex items-center gap-3 bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] px-4 py-2.5 active:scale-[0.98] transition-all duration-200">
                <div className={`absolute inset-0 rounded-2xl pointer-events-none ${selectedSocialBar === 'steam' ? 'accent-overlay-on' : 'accent-overlay-off'}`} style={{background:'rgba(11,121,172,0.25)'}} />
                <div className="absolute left-0 top-3 bottom-3 w-[3px] rounded-r-full flex-shrink-0" style={{background:'#0B79AC'}} />
                <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0">
                  <img src="/steam.png" alt="Steam" className="w-7 h-7 object-contain" />
                </div>
                <div className="text-white font-semibold leading-none uppercase tracking-widest text-[0.65rem] md:text-[0.82rem]" style={{fontFamily:"'Outfit', 'Inter', sans-serif", letterSpacing:'0.12em'}}>Steam</div>
                <div className="absolute right-3 top-0 bottom-0 flex flex-col justify-between items-end py-2">
                  <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>&nbsp;</span>
                  <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>&nbsp;</span>
                  <span className="text-slate-500 font-medium" style={{fontSize:'0.6rem', lineHeight:1}}>cheeks</span>
                </div>
              </a>

            </div>

            {/* Hunting + New Product row */}
            <div className="grid grid-cols-2 gap-3 items-start">

              {/* New Product card */}
              <button onClick={() => { switchTab('creations'); setTimeout(() => { document.getElementById('digital-stand-card')?.scrollIntoView({behavior:'smooth', block:'start'}); }, 120); }} className="bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] overflow-hidden active:scale-[0.98] transition-all duration-150 text-left w-full flex flex-col">
                {/* Image with NEW ribbon overlaid at top-left */}
                <div className="relative mx-3 mt-3 rounded-xl overflow-hidden border border-slate-700/50 bg-slate-900/80 flex-shrink-0" style={{height:'110px'}}>
                  {/* NEW ribbon — sits flush to top-left of image */}
                  <div className="absolute top-0 left-0 z-10 flex items-center gap-1 px-2.5 py-1" style={{background:'linear-gradient(90deg,#0ea5e9,#3b82f6)', clipPath:'polygon(0 0,100% 0,calc(100% - 6px) 50%,100% 100%,0 100%)', borderRadius:'0.75rem 0 0 0'}}>
                    <svg width="8" height="8" viewBox="0 0 24 24" fill="white" stroke="none" className="flex-shrink-0"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                    <span className="text-white text-[9px] font-bold uppercase" style={{letterSpacing:'0.1em', fontFamily:"'Outfit','Inter',sans-serif"}}>NEW</span>
                  </div>
                  <div className="absolute inset-0" style={{background:'radial-gradient(ellipse at 50% 50%, rgba(34,211,238,0.18) 0%, rgba(59,130,246,0.08) 50%, transparent 75%)'}} />
                  <img src="/digital_stand.png" alt="Digital Display Stand" className="absolute inset-0 w-full h-full object-contain p-2" style={{zIndex:1}} onError={(e) => { e.target.style.display='none'; }} />
                </div>
                {/* Info */}
                <div className="px-3 pt-2 pb-2 flex-1">
                  <p className="text-white text-[11px] font-semibold leading-tight">Digital Display Stand <span className="text-[9px] font-bold text-cyan-400">V2</span></p>
                  <p className="text-slate-500 text-[9px] font-medium leading-snug mt-0.5">4 Colour Greyscale</p>
                </div>
                {/* Bottom strip — same height as Hunting's strip */}
                <div className="border-t border-slate-700/40 px-3 py-2 flex items-center justify-between h-9">
                  <span className="text-slate-500 text-[9px] font-medium">Available now</span>
                  <div className="flex items-baseline gap-1">
                    <span className="text-slate-500 font-semibold uppercase" style={{fontSize:'0.55rem', letterSpacing:'0.08em'}}>From</span>
                    <span className="text-white text-[10px] font-bold">£79.99</span>
                  </div>
                </div>
              </button>

              {/* New Product V3 card */}
              <button onClick={() => { switchTab('creations'); setTimeout(() => { document.getElementById('v3-card')?.scrollIntoView({behavior:'smooth', block:'start'}); }, 120); }} className="bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] overflow-hidden active:scale-[0.98] transition-all duration-150 text-left w-full flex flex-col">
                {/* Image with NEW ribbon overlaid at top-left */}
                <div className="relative mx-3 mt-3 rounded-xl overflow-hidden border border-slate-700/50 bg-slate-900/80 flex-shrink-0" style={{height:'110px'}}>
                  {/* NEW ribbon — sits flush to top-left of image */}
                  <div className="absolute top-0 left-0 z-10 flex items-center gap-1 px-2.5 py-1" style={{background:'linear-gradient(90deg,#0ea5e9,#3b82f6)', clipPath:'polygon(0 0,100% 0,calc(100% - 6px) 50%,100% 100%,0 100%)', borderRadius:'0.75rem 0 0 0'}}>
                    <svg width="8" height="8" viewBox="0 0 24 24" fill="white" stroke="none" className="flex-shrink-0"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                    <span className="text-white text-[9px] font-bold uppercase" style={{letterSpacing:'0.1em', fontFamily:"'Outfit','Inter',sans-serif"}}>NEW</span>
                  </div>
                  <div className="absolute inset-0" style={{background:'radial-gradient(ellipse at 50% 50%, rgba(34,211,238,0.18) 0%, rgba(59,130,246,0.08) 50%, transparent 75%)'}} />
                  <div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5" style={{zIndex:1}}>
                    <div className="w-7 h-7 rounded-md flex items-center justify-center" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                      <img src="/pball.svg" alt="" className="h-4 w-4 animate-spin" style={{animationDuration:'2s', filter:'brightness(0) invert(1)'}} />
                    </div>
                    <span className="text-slate-500 text-[9px] font-medium">Image Coming Soon</span>
                  </div>
                </div>
                <div className="px-3 pt-2 pb-2 flex-1">
                  <p className="text-white text-[11px] font-semibold leading-tight">Digital Display Stand <span className="text-[9px] font-bold text-cyan-400">V3</span></p>
                  <p className="text-slate-500 text-[9px] font-medium leading-snug mt-0.5">Full Colour</p>
                </div>
                <div className="border-t border-slate-700/40 px-3 py-2 flex items-center justify-between h-9">
                  <span className="text-slate-500 text-[9px] font-medium">Available soon</span>
                  <div className="flex items-baseline gap-1">
                    <span className="text-slate-500 font-semibold uppercase" style={{fontSize:'0.55rem', letterSpacing:'0.08em'}}>From</span>
                    <span className="text-white text-[10px] font-bold">£149.99</span>
                  </div>
                </div>
              </button>

            </div>

            {/* ── CUSTOMER REVIEWS SCROLL ── */}
            {(() => {
              const reviews = [
                { user: 'dmxxre_', text: "I honestly can't express how amazing this person is. They were kind enough to let a rare card go for practically nothing — I only paid postage and £1. The card arrived with a beautifully made 3D-printed Wooper keychain as a gift. Truly one of the loveliest sellers I've met." },
                { user: 'wolfsterj', text: "Fantastic seller, one of the best people on the app." },
                { user: 'tjdeku', text: "First stream back after time and you absolutely smashed it mate, quality stock, great guy — couldn't recommend you more. Looking forward to more streams in future." },
                { user: 'stormtcg', text: "Cheeeks is seriously the best! Love his vibe and enjoy his product. Shipping was pretty quick considering he's international. Everything arrived wonderfully!" },
                { user: 'taylor2704', text: "Togecheeks has the best collection of rarest gems I've seen! Amazing seller. Super quick and packaged perfect! Can't wait for your next stream!" },
                { user: 'richiebear_collects', text: "Absolutely love cheeks streams, always a blast to buy from you. Highly recommended seller." },
                { user: 'cazz944', text: "Great cards, great prices, amazing host and great vibes in stream." },
                { user: 'moose0007', text: "Vintage single and vintage pack… UK to Oklahoma… zero issues, perfect condition upon arrival. Amazing streamer and an even better person!" },
                { user: 'bthowe00', text: "Massively impressive streamer, does a lot to support others too. Check him out and give him a follow." },
                { user: 'yukocreep', text: "Fantastic job on every streaming. Love the set up, how cute and interesting to be in his show. Arigatou for the great experience!" },
                { user: 'pokemart92', text: "Awesome streamer! Great guy. Packaged perfectly and swiftly delivered. Highly recommend this cheeky chap!" },
                { user: 'lucybytes', text: "Lovely streamer, fun and great bargains to be had here." },
              ];
              return (
                <div className="bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] overflow-hidden">
                  <style>{`
                    @keyframes reviewFadeUp {
                      0%   { opacity: 0; transform: translateY(8px); }
                      12%  { opacity: 1; transform: translateY(0); }
                      80%  { opacity: 1; transform: translateY(0); }
                      100% { opacity: 0; transform: translateY(-8px); }
                    }
                    .review-slide { animation: reviewFadeUp 6s ease-in-out forwards; }
                  `}</style>
                  {/* Header */}
                  <div className="flex items-center justify-between px-4 py-2.5 border-b border-slate-700/50">
                    <div className="flex items-center gap-2">
                      <div className="flex">
                        {[1,2,3,4,5].map(i => (
                          <svg key={i} width="10" height="10" viewBox="0 0 24 24" fill="#FADC00"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                        ))}
                      </div>
                      <span className="text-white text-[11px] font-bold">5.0</span>
                    </div>
                    <span id="review-username" className="text-slate-400 text-[10px] font-semibold">@{reviews[0].user}</span>
                  </div>
                  {/* Single cycling review — both username label and text update together */}
                  <div className="px-4 py-3 relative flex flex-col justify-center" style={{height:'110px', overflow:'hidden'}}
                    ref={el => {
                      if (!el || el._reviewInit) return;
                      el._reviewInit = true;
                      let idx = 0;
                      const show = () => {
                        const r = reviews[idx % reviews.length];
                        // Update username in header in sync
                        const userEl = document.getElementById('review-username');
                        if (userEl) {
                          userEl.style.transition = 'opacity 0.3s';
                          userEl.style.opacity = '0';
                          setTimeout(() => {
                            userEl.textContent = '@' + r.user;
                            userEl.style.opacity = '1';
                          }, 300);
                        }
                        el.innerHTML = `<div class="review-slide"><p style="color:rgba(203,213,225,0.9);font-size:0.7rem;line-height:1.5;">"${r.text}"</p></div>`;
                        idx++;
                      };
                      show();
                      setInterval(show, 6000);
                    }}
                  />
                </div>
              );
            })()}

            {/* Fun Fact Panel */}
            {funFact && (
              <div className="bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] px-4 py-3 flex items-start gap-3">
                <img src="/pball.svg" alt="" className="h-4 w-4 flex-shrink-0 mt-0.5" style={{filter:'brightness(0) saturate(100%) invert(43%) sepia(8%) saturate(869%) hue-rotate(175deg) brightness(95%) contrast(87%)'}} />
                <p className="text-slate-500 leading-relaxed" style={{fontSize:'0.7rem'}}>{funFact}</p>
              </div>
            )}

          </div>
        </main>
      )}

      {/* ══════════════════════════════════════════
          INVENTORY TAB
      ══════════════════════════════════════════ */}
      {activeTab === 'inventory' && (
        <main className="flex-1">
          <style>{`
            @keyframes inventoryFadeUp {
              from { opacity: 0; transform: translateY(14px); }
              to   { opacity: 1; transform: translateY(0); }
            }
            .inv-card {
              animation: inventoryFadeUp 0.35s ease both;
            }
          `}</style>

          {/* Grid */}
          <div className="max-w-7xl mx-auto px-3 py-4">

            {/* Inventory updating bar */}
            <div className="flex items-center gap-3 bg-slate-800/40 border border-slate-700/40 rounded-2xl px-4 py-2 mb-4">
              <div className="w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                <img src="/pball.svg" alt="" className="h-4 w-4 animate-spin" style={{animationDuration:"2s", filter:"brightness(0) invert(1)"}} />
              </div>
              <div className="w-px h-6 bg-slate-700/60 flex-shrink-0" />
              <div>
                <p className="text-slate-300 text-xs font-semibold leading-none">Inventory Updating...</p>
                <p className="text-slate-500 text-[10px] mt-0.5 leading-none">New items are being added to this page shortly.</p>
              </div>
            </div>

            {filteredImages.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3">
                {filteredImages.map((image, idx) => (
                  <div
                    key={image.id}
                    className="inv-card group bg-slate-800/90 backdrop-blur-sm rounded-xl border border-slate-700/50 hover:border-cyan-400/50 active:border-cyan-400/50 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-400/10 overflow-hidden cursor-pointer shadow-[0_4px_16px_rgba(0,0,0,0.25)] hover:-translate-y-0.5"
                    style={{animationDelay:`${Math.min(idx * 0.03, 0.6)}s`}}
                    onClick={() => setSelectedInventoryImage(image)}
                  >
                    <div className="aspect-square bg-slate-700/50 flex items-center justify-center relative overflow-hidden">
                      <img
                        src={`/${image.folder}/${image.filename}`}
                        alt={image.name}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                        onLoad={(e) => {
                          if (e.target.nextSibling) e.target.nextSibling.style.display = 'none';
                        }}
                      />
                      <div className="absolute inset-0 bg-gradient-to-br from-slate-700 via-slate-600 to-slate-700 flex items-center justify-center" style={{ display: 'none' }}>
                        <div className="text-center p-4">
                          <div className="w-16 h-16 mx-auto mb-2 opacity-30">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-slate-500">
                              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" strokeWidth="2"/>
                              <circle cx="8.5" cy="8.5" r="1.5" strokeWidth="2"/>
                              <polyline points="21 15 16 10 5 21" strokeWidth="2"/>
                            </svg>
                          </div>
                          <p className="text-xs text-slate-500 font-medium">Image not found</p>
                        </div>
                      </div>

                      {image.grade && (
                        <div className="absolute top-2 left-2 bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-2 py-1 rounded-md text-xs font-bold shadow-lg backdrop-blur-sm border border-cyan-400/50">
                          {image.grade}
                        </div>
                      )}

                      {image.serial && (
                        <div className="absolute text-white font-bold tracking-widest shadow-lg" style={{bottom:'6px', left:'6px', fontSize:'0.6rem', background:'rgba(0,0,0,0.4)', backdropFilter:'blur(4px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:'5px', padding:'2px 6px', letterSpacing:'0.08em'}}>
                          {image.serial}
                        </div>
                      )}

                      {/* Team badge tab — sticks up from info bar, bottom right */}
                      {image.filename.includes('Crystal Palace') && (
                        <div className="absolute bottom-0" style={{right:'6px', zIndex:2}}>
                          <div className="flex items-center justify-center px-2 pt-1.5 pb-0 rounded-t-lg" style={{background:'rgb(30,41,59)', width:'36px'}}>
                            <img src="/cpfc.png" alt="CPFC" style={{width:'22px', height:'22px', objectFit:'contain'}} />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="p-2.5">
                      <h3 className="text-xs font-semibold text-white mb-1 group-hover:text-cyan-400 transition-colors leading-tight">
                        {image.name}
                      </h3>
                      {image.set.split('  ').map((line, idx) => (
                        <p key={idx} className="text-[10px] text-slate-400 leading-tight">{line}</p>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700/50 rounded-xl p-12 text-center">
                <p className="text-slate-400">No items found matching your search.</p>
              </div>
            )}
          </div>
        </main>
      )}

      {/* ══════════════════════════════════════════
          CREATIONS TAB
      ══════════════════════════════════════════ */}
      {activeTab === 'creations' && (
        <main className="flex-1">
          <style>{`
            @keyframes creationFadeUp {
              from { opacity: 0; transform: translateY(18px); }
              to   { opacity: 1; transform: translateY(0); }
            }
            @keyframes bellRing {
              0%,100% { transform: rotate(0deg); }
              10%     { transform: rotate(14deg); }
              20%     { transform: rotate(-12deg); }
              30%     { transform: rotate(10deg); }
              40%     { transform: rotate(-8deg); }
              50%     { transform: rotate(0deg); }
            }
            .creation-card {
              animation: creationFadeUp 0.45s ease both;
            }
            .instructions-body {
              display: grid;
              grid-template-rows: 0fr;
              transition: grid-template-rows 0.35s ease;
            }
            .instructions-body.open {
              grid-template-rows: 1fr;
            }
            .instructions-inner {
              overflow: hidden;
            }
            @keyframes shimmer {
              0%   { background-position: -200% center; }
              100% { background-position: 200% center; }
            }
            .instructions-shimmer {
              background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.03) 45%, rgba(255,255,255,0.07) 50%, rgba(255,255,255,0.03) 55%, transparent 100%);
              background-size: 200% auto;
              animation: shimmer 4s ease-in-out infinite;
            }
            .epaper-img {
              filter: grayscale(100%) contrast(1.4) brightness(1.1);
              image-rendering: pixelated;
            }
          `}</style>
          <svg width="0" height="0" style={{position:'absolute'}}>
            <defs>
              <filter id="epaper">
                <feColorMatrix type="saturate" values="0"/>
                <feComponentTransfer>
                  <feFuncR type="discrete" tableValues="0 0.42 0.78 1"/>
                  <feFuncG type="discrete" tableValues="0 0.42 0.78 1"/>
                  <feFuncB type="discrete" tableValues="0 0.42 0.78 1"/>
                </feComponentTransfer>
              </filter>
            </defs>
          </svg>

          <div className="max-w-2xl mx-auto px-4 py-6">
            <div className="flex flex-col gap-5">

            {/* Designed & manufactured bar */}
            <div className="flex items-center gap-3 bg-slate-800/40 border border-slate-700/40 rounded-2xl px-4 py-2">
              <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                <img src="https://flagcdn.com/gb.svg" alt="UK" className="w-5 h-5 rounded-full object-cover" style={{aspectRatio:'1/1'}} />
              </div>
              <div className="w-px h-6 bg-slate-700/60 flex-shrink-0" />
              <div>
                <p className="text-slate-300 text-xs font-semibold leading-none">Designed and manufactured by CHEEKS in the United Kingdom</p>
              </div>
            </div>
            <div id="v3-card" className="creation-card bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] overflow-hidden">
              {/* Product image — placeholder */}
              <div className="relative w-full overflow-hidden flex items-center justify-center" style={{aspectRatio:'4/3', background:'radial-gradient(ellipse at 60% 50%, rgba(34,211,238,0.08) 0%, rgba(59,130,246,0.06) 40%, rgba(15,23,42,0.0) 70%)'}}>
                <svg style={{position:'absolute',inset:0,width:'100%',height:'100%',zIndex:0}} viewBox="0 0 600 450" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                  <defs>
                    <pattern id="cgridv3" width="40" height="40" patternUnits="userSpaceOnUse">
                      <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(34,211,238,0.18)" strokeWidth="0.5"/>
                    </pattern>
                  </defs>
                  <rect width="600" height="450" fill="url(#cgridv3)"/>
                </svg>
                <div className="absolute bottom-0 left-0 right-0 h-1/2" style={{background:'linear-gradient(to top, rgba(59,130,246,0.06), transparent)', zIndex:0}} />
                {/* Centre placeholder — spinning pokeball + text */}
                <div className="flex flex-col items-center justify-center gap-3" style={{position:'relative', zIndex:2}}>
                  <div className="w-10 h-10 rounded-md flex items-center justify-center" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                    <img src="/pball.svg" alt="" className="h-6 w-6 animate-spin" style={{animationDuration:'2s', filter:'brightness(0) invert(1)'}} />
                  </div>
                  <span className="text-slate-400 font-semibold tracking-wide" style={{fontSize:'0.85rem'}}>Image Coming Soon</span>
                </div>
                {/* Full Colour pill — top right */}
                <div className="absolute top-3 right-3 flex items-center gap-1.5 px-2 py-1 rounded-md text-[10px] font-bold text-white" style={{background:'linear-gradient(135deg, #22d3ee, #3b82f6)', zIndex:3}}>
                  Full Colour
                </div>
                {/* V3 version badge — bottom left */}
                <div className="absolute bottom-3 left-3 flex items-center justify-center rounded-full text-white font-bold text-[11px]" style={{width:'28px', height:'28px', background:'linear-gradient(135deg,#22d3ee,#3b82f6)', zIndex:3, boxShadow:'0 0 8px rgba(34,211,238,0.4)'}}>
                  V3
                </div>
                {/* Mini preview placeholder — top left (600×400 ratio, taller than V2) */}
                <div className="absolute top-3 left-3 flex flex-col items-start gap-1.5" style={{zIndex:3}}>
                  <div className="rounded-lg overflow-hidden border border-slate-600/50 flex items-center justify-center" style={{width:'99px', height:'66px', background:'#0f172a'}}>
                    <div className="flex flex-col items-center gap-1 opacity-40">
                      <img src="/pball.svg" alt="" className="h-5 w-5 animate-spin" style={{animationDuration:'2s', filter:'brightness(0) saturate(100%) invert(70%) sepia(50%) saturate(400%) hue-rotate(160deg)'}} />
                    </div>
                  </div>
                  <div className="w-full text-center px-2 py-0.5 rounded-full text-[9px] font-semibold text-white/70" style={{background:'rgba(0,0,0,0.75)'}}>
                    Example content
                  </div>
                </div>
                {/* Thumbnail placeholders — bottom right */}
                <div className="absolute bottom-3 right-3 flex items-center gap-2" style={{zIndex:3}}>
                  {[1, 2, 3].map((i) => (
                    <div
                      key={i}
                      className="rounded-lg overflow-hidden flex items-center justify-center"
                      style={{
                        width: '44px',
                        height: '44px',
                        background: '#0f172a',
                        border: '2px solid rgba(255,255,255,0.15)',
                      }}
                    >
                      <img src="/pball.svg" alt="" className="h-5 w-5 animate-spin" style={{animationDuration:'2s', filter:'brightness(0) saturate(100%) invert(70%) sepia(50%) saturate(400%) hue-rotate(160deg)', opacity:0.35}} />
                    </div>
                  ))}
                </div>
              </div>

              {/* Info block */}
              <div className="px-4 pt-4 pb-3">
                <div className="flex items-center justify-between gap-2 mb-3">
                  <h2 className="text-white font-bold text-base leading-tight">Digital Display Card &amp; Slab Stand V3</h2>
                  <div className="flex-shrink-0 flex items-center gap-1 px-2.5 py-1 rounded-full" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                    <span className="text-white font-semibold uppercase tracking-widest" style={{fontSize:'0.55rem'}}>From</span>
                    <span className="text-white font-bold text-base leading-tight">£149.99</span>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 mb-3">
                  {[
                    'Full Colour',
                    'Wireless Control',
                    'Low Power',
                    'Stream Deck Ready',
                    'Easy Setup',
                    'No App Required',
                    'Plug & Play',
                    'Always-On Display',
                  ].map((point) => (
                    <div key={point} className="flex items-center gap-1.5">
                      <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                        <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                      </div>
                      <span className="text-slate-300 font-medium" style={{fontSize:'0.7rem'}}>{point}</span>
                    </div>
                  ))}
                </div>
                <p className="text-slate-400 text-xs leading-relaxed">A wirelessly controlled display stand with a full colour screen, designed for graded slabs and raw cards from all major TCGs — Pokémon, MTG, Yu-Gi-Oh!, Disney, Sports and more. Change what's shown on screen from any device on your Wi-Fi: custom graphics, shout-outs, offers, discount codes, or stream overlays. Stream Deck compatible. The screen holds its image without power — and is only needed when updating the display.</p>
              </div>

              {/* Divider + Setup Instructions (greyed - coming soon) */}
              <div className="border-t border-slate-700/50" />
              <div className="relative px-4 py-2 pointer-events-none select-none">
                <div className="absolute inset-0 bg-slate-900/60 rounded-none z-10 flex items-center justify-center">
                  <span className="text-slate-500 text-[10px] font-semibold uppercase tracking-widest flex items-center gap-1.5">
                    <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                    Updating...
                  </span>
                </div>
                <div className="w-full flex items-center justify-between opacity-30">
                  <div className="flex items-center gap-3">
                    <div className="w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0" style={{background:'#334155'}}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                      </svg>
                    </div>
                    <div className="w-px h-6 bg-slate-700/60 flex-shrink-0" />
                    <div className="text-left">
                      <span className="text-xs font-semibold text-slate-500">Setup Instructions</span>
                      <p className="text-slate-600 mt-0.5" style={{fontSize:'0.6rem'}}>Follow these steps to get your device connected and ready to use.</p>
                    </div>
                  </div>
                  <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0" style={{background:'#334155'}}>
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="9 18 15 12 9 6"/>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="border-t border-slate-700/50" />

              {/* Update Firmware (greyed - coming soon) */}
              <div className="relative px-4 py-2 pointer-events-none select-none">
                <div className="absolute inset-0 bg-slate-900/60 rounded-none z-10 flex items-center justify-center">
                  <span className="text-slate-500 text-[10px] font-semibold uppercase tracking-widest flex items-center gap-1.5">
                    <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                    Updating...
                  </span>
                </div>
                <div className="w-full flex items-center justify-between opacity-30">
                  <div className="flex items-center gap-3">
                    <div className="w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0" style={{background:'#334155'}}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/>
                      </svg>
                    </div>
                    <div className="w-px h-6 bg-slate-700/60 flex-shrink-0" />
                    <div>
                      <span className="text-xs font-semibold text-slate-500">Update Firmware</span>
                      <p className="text-slate-600 mt-0.5" style={{fontSize:'0.6rem'}}>Keep your device up to date with the latest features.</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="flex flex-col items-end gap-0.5">
                      <span className="font-mono" style={{fontSize:'0.55rem', color:'#475569'}}>Latest: v1.2.0</span>
                    </div>
                    <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0" style={{background:'#334155'}}>
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="9 18 15 12 9 6"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-t border-slate-700/50" />

            </div>

            {/* ── CREATION CARD ── */}
            {[{
              id: 1,
              name: 'Digital Display Card & Slab Stand V2',
              tag: '3D Printed',
              badge: 'Digital + Physical',
              description: 'A wirelessly controlled display stand, designed for graded slabs and raw cards from all major TCGs — Pokémon, MTG, Yu-Gi-Oh!, Disney, Sports and more. Change what\'s shown on screen from any device on your Wi-Fi: custom graphics, shout-outs, offers, discount codes, or stream overlays. Stream Deck compatible. The screen holds its image without power — and is only needed when updating the display.',
              price: '£79.99',
              availability: 'Available',
              steps: [
                {
                  title: 'Power On',
                  detail: 'Unbox your stand and plug it into a power source using the provided USB cable. The device will boot up automatically within seconds.'
                },
                {
                  title: 'Connect to Display Network',
                  detail: <span>On your smartphone or computer, open your Wi-Fi settings and connect to the network named: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22d3ee" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{display:'inline',verticalAlign:'middle',marginRight:'3px'}}><path d="M5 12.55a11 11 0 0 1 14.08 0"/><path d="M1.42 9a16 16 0 0 1 21.16 0"/><path d="M8.53 16.11a6 6 0 0 1 6.95 0"/><line x1="12" y1="20" x2="12.01" y2="20"/></svg><strong className="text-cyan-400">Digital Display</strong></span>
                },
                {
                  title: 'Configure Your Device',
                  detail: <span>Once connected, a setup page should automatically open — if it doesn't, navigate to <code className="px-1.5 py-0.5 rounded text-cyan-400 font-mono text-[11px]" style={{background:'rgba(34,211,238,0.1)', border:'1px solid rgba(34,211,238,0.2)'}}>192.168.4.1</code> in your browser. Click the Scan WiFi button and select the network you want to use, enter your WiFi password and a device name (e.g. "My Stream Stand"), then tap Complete & Restart.</span>,
                },
                {
                  title: 'Complete Setup',
                  detail: 'The device will reboot and connect to your network. A "Success" message will appear on the screen along with the control panels IP Address (e.g. 192.168.1.50) — note this down or bookmark it.'
                },
                {
                  title: 'Access Control Panel',
                  detail: 'Type the control panel IP Address into a web browser on any device connected to the same WiFi network. From here you can manage and push content to your display!'
                },
              ]
            }].map((item) => (
              <div key={item.id} id="digital-stand-card" className="creation-card bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] overflow-hidden">

                {/* Product image */}
                <div className="relative w-full overflow-hidden" style={{aspectRatio:'4/3', background:'radial-gradient(ellipse at 50% 55%, rgba(34,211,238,0.07) 0%, rgba(59,130,246,0.05) 40%, rgba(15,23,42,0.0) 75%)'}}>
                  {/* Orb glow */}
                  <style>{`
                    @keyframes centerGlow {
                      0%   { opacity: 0.55; transform: scale(0.9) translateY(0px); }
                      35%  { opacity: 1;    transform: scale(1.1) translateY(-8px); }
                      65%  { opacity: 0.7;  transform: scale(0.95) translateY(5px); }
                      100% { opacity: 0.55; transform: scale(0.9) translateY(0px); }
                    }
                    @keyframes centerGlow2 {
                      0%   { opacity: 0.35; transform: scale(1) translateX(0px); }
                      45%  { opacity: 0.65; transform: scale(1.15) translateX(10px); }
                      75%  { opacity: 0.4;  transform: scale(0.92) translateX(-8px); }
                      100% { opacity: 0.35; transform: scale(1) translateX(0px); }
                    }
                    .center-glow  { animation: centerGlow  3.8s ease-in-out infinite; will-change: transform, opacity; }
                    .center-glow2 { animation: centerGlow2 5.2s ease-in-out 1.2s infinite; will-change: transform, opacity; }
                  `}</style>
                  <div className="center-glow absolute" style={{top:'-10%',left:'-5%',right:'-5%',bottom:'-10%',background:'radial-gradient(ellipse at 50% 50%, rgba(34,211,238,0.32) 0%, rgba(59,130,246,0.18) 35%, transparent 65%)',filter:'blur(40px)',zIndex:1,transformOrigin:'50% 50%'}} />
                  <div className="center-glow2 absolute" style={{top:'-5%',left:'0%',right:'0%',bottom:'-5%',background:'radial-gradient(ellipse at 50% 50%, rgba(99,102,241,0.22) 0%, rgba(34,211,238,0.12) 40%, transparent 68%)',filter:'blur(50px)',zIndex:1,transformOrigin:'50% 50%'}} />
                  {/* Circuit SVG — grid only */}
                  <svg style={{position:'absolute',inset:0,width:'100%',height:'100%',zIndex:2}} viewBox="0 0 600 450" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                    <defs>
                      <pattern id="cgrid" width="40" height="40" patternUnits="userSpaceOnUse">
                        <path d="M 40 0 L 0 0 0 40" fill="none" stroke="rgba(34,211,238,0.18)" strokeWidth="0.5"/>
                      </pattern>
                    </defs>
                    <rect width="600" height="450" fill="url(#cgrid)"/>
                  </svg>

                  <img
                    src={selectedStandImage}
                    alt={item.name}
                    className="w-full h-full object-contain px-8"
                    style={{position:'relative', zIndex:2}}
                  />
                  {/* New Improved Design pill — top right */}
                  <div className="absolute top-3 right-3 flex items-center gap-1.5 px-2 py-1 rounded-md text-[10px] font-bold text-white" style={{background:'linear-gradient(135deg, #22d3ee, #3b82f6)'}}>
                    New Improved Design
                  </div>
                  {/* Mini cycling display — top left */}
                  <div className="absolute top-3 left-3 flex flex-col items-start gap-1.5">
                    <div className="relative rounded overflow-hidden" style={{width:'99px', height:'43px', background:'#0f172a'}}>
                      {[1,2,3,4,5].map((n) => (
                        <img
                          key={n}
                          src={`/display${n}.png`}
                          alt={`Display example ${n}`}
                          className="absolute inset-0 w-full h-full object-cover"
                          style={{
                            opacity: displayImageIndex === n - 1 ? 1 : 0,
                            filter: 'url(#epaper)',
                            transition: 'opacity 0.7s ease',
                          }}
                        />
                      ))}
                    </div>
                    <div className="w-full text-center px-2 py-0.5 rounded-full text-[9px] font-semibold text-white/70" style={{background:'rgba(0,0,0,0.75)'}}>
                      Example content
                    </div>
                  </div>
                  {/* V2 version badge — bottom left */}
                  <div className="absolute bottom-3 left-3 flex items-center justify-center rounded-full text-white font-bold text-[11px]" style={{width:'28px', height:'28px', background:'linear-gradient(135deg,#22d3ee,#3b82f6)', boxShadow:'0 0 8px rgba(34,211,238,0.4)', zIndex:3}}>
                    V2
                  </div>
                  {/* Thumbnail gallery — bottom right */}
                  <div className="absolute bottom-3 right-3 flex items-center gap-2" style={{zIndex:3}}>
                    {['/digital_stand.png', '/digital_stand_rear.png', '/digital_stand_side.png'].map((src, i) => (
                      <button
                        key={i}
                        onClick={() => setSelectedStandImage(src)}
                        className="rounded-lg overflow-hidden transition-all duration-200"
                        style={{
                          width: '44px',
                          height: '44px',
                          background: '#0f172a',
                          border: selectedStandImage === src ? '2px solid #22d3ee' : '2px solid rgba(255,255,255,0.15)',
                          boxShadow: selectedStandImage === src ? '0 0 8px rgba(34,211,238,0.4)' : 'none',
                        }}
                      >
                        <img src={src} alt={`View ${i + 1}`} className="w-full h-full object-contain p-1" />
                      </button>
                    ))}
                  </div>

                  {/* Per-image labels */}
                  <style>{`
                    @keyframes labelPop {
                      0%   { opacity:0; transform: scale(0.8) translateY(4px); }
                      60%  { transform: scale(1.05) translateY(-1px); }
                      100% { opacity:1; transform: scale(1) translateY(0); }
                    }
                    .img-label { animation: labelPop 0.3s cubic-bezier(0.34,1.56,0.64,1) both; }
                  `}</style>
                  {({
                    '/digital_stand.png': [
                      { text: '2.9" Glass Display', style: { top: '22%', right: '6%' } },
                      { text: 'Display Without Power', style: { bottom: '22%', left: '8%' } },
                    ],
                    '/digital_stand_rear.png': [
                      { text: 'USB-C Port', style: { bottom: '22%', left: '8%' } },
                      { text: 'WiFi + Bluetooth', style: { top: '28%', right: '6%' } },
                    ],
                    '/digital_stand_side.png': [
                      { text: 'Precision Designed', style: { top: '22%', right: '6%' } },
                      { text: 'Impossibly Compact', style: { bottom: '22%', left: '6%' } },
                    ],
                  }[selectedStandImage] || []).map((label, i) => (
                    <div
                      key={`${selectedStandImage}-${i}`}
                      className="img-label absolute flex items-center gap-1.5 px-3 py-1.5 rounded-full text-white font-semibold pointer-events-none"
                      style={{
                        fontSize: '0.75rem',
                        background: 'rgba(15,23,42,0.82)',
                        border: '1px solid rgba(255,255,255,0.15)',
                        backdropFilter: 'blur(8px)',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
                        zIndex: 4,
                        animationDelay: `${i * 0.08}s`,
                        ...label.style,
                      }}
                    >
                      <span style={{width:'6px',height:'6px',borderRadius:'50%',background:'rgba(34,211,238,0.8)',flexShrink:0,display:'inline-block'}} />
                      {label.text}
                    </div>
                  ))}
                </div>

                {/* Info block */}
                <div className="px-4 pt-4 pb-3">
                  <div className="flex items-center justify-between gap-2 mb-3">
                    <h2 className="text-white font-bold text-base leading-tight">{item.name}</h2>
                    <div className="flex-shrink-0 flex items-center gap-1 px-2.5 py-1 rounded-full" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                      <span className="text-white font-semibold uppercase tracking-widest" style={{fontSize:'0.55rem'}}>From</span>
                      <span className="text-white font-bold text-base leading-tight">{item.price}</span>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2 mb-3">
                    {[
                      '4 Colour Greyscale',
                      'Wireless Control',
                      'Low Power',
                      'Stream Deck Ready',
                      'Easy Setup',
                      'No App Required',
                      'Plug & Play',
                      'Always-On Display',
                    ].map((point) => (
                      <div key={point} className="flex items-center gap-1.5">
                        <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                          <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                        </div>
                        <span className="text-slate-300 font-medium" style={{fontSize:'0.7rem'}}>{point}</span>
                      </div>
                    ))}
                  </div>
                  <p className="text-slate-400 text-xs leading-relaxed">{item.description}</p>
                </div>

                <div className="border-t border-slate-700/50" />
                <div className="px-4 pt-2 pb-0">
                  <button
                    onClick={() => { setExpandedInstructions(expandedInstructions === item.id ? null : item.id); setExpandedFirmware(null); }}
                    className="w-full flex items-center justify-between group pb-2"
                  >
                    <div className="flex items-center gap-3">
                      <div className="w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                        </svg>
                      </div>
                      <div className="w-px h-6 bg-slate-700/60 flex-shrink-0" />
                      <div className="text-left">
                        <span className="text-xs font-semibold text-slate-300 group-hover:text-white transition-colors">Setup Instructions</span>
                        <p className="text-slate-500 mt-0.5" style={{fontSize:'0.6rem'}}>Follow these steps to get your device connected and ready to use.</p>
                      </div>
                    </div>
                    <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)', transform: expandedInstructions === item.id ? 'rotate(90deg)' : 'rotate(0deg)'}}>
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="9 18 15 12 9 6"/>
                      </svg>
                    </div>
                  </button>
                </div>
                <div className={`instructions-body${expandedInstructions === item.id ? ' open' : ''}`}>
                  <div className="instructions-inner px-4">
                      <div className="mt-3 flex flex-col rounded-xl overflow-hidden border border-slate-700/40">
                        {item.steps.map((step, i) => (
                          <div key={i} className={`flex flex-col px-3 py-3 ${i < item.steps.length - 1 ? 'border-b border-slate-700/40' : ''} ${i % 2 === 0 ? 'bg-slate-900/30' : 'bg-slate-800/20'}`}>
                            <div className="flex items-start gap-3">
                              <span className="flex-shrink-0 w-5 h-5 mt-0.5 rounded-md flex items-center justify-center text-[9px] font-bold text-slate-400 bg-slate-700/60 border border-slate-600/50">
                                {i + 1}
                              </span>
                              <div>
                                <p className="text-white text-xs font-semibold mb-0.5">{step.title}</p>
                                <p className="text-slate-400 text-xs leading-relaxed">{step.detail}</p>
                              </div>
                            </div>
                            {/* Step mockup */}
                            {i === 0 && (
                              <div className="mt-3 mx-1 rounded-lg overflow-hidden border border-slate-700/40">
                                <svg width="100%" viewBox="0 0 680 160" xmlns="http://www.w3.org/2000/svg">
                                  <style>{`
                                    @keyframes plugIn { 0%{transform:translateX(60px);} 60%{transform:translateX(0px);} 80%{transform:translateX(-3px);} 100%{transform:translateX(0px);} }
                                    @keyframes flowDash { 0%{stroke-dashoffset:24} 100%{stroke-dashoffset:0} }
                                    @keyframes fadeFlow { 0%,50%{opacity:0} 70%,100%{opacity:1} }
                                    .plug-group { animation: plugIn 2s cubic-bezier(0.4,0,0.2,1) infinite; transform-origin: 172px 80px; }
                                    .flow { animation: flowDash 0.5s linear infinite, fadeFlow 2s ease infinite; }
                                  `}</style>
                                  <rect x="0" y="0" width="680" height="160" fill="#0f172a" rx="10"/>
                                  <text x="80" y="80" textAnchor="middle" fill="#22d3ee" fontSize="16" fontFamily="monospace" fontWeight="700" letterSpacing="2" transform="rotate(-90, 80, 80)">USB</text>
                                  <rect x="100" y="40" width="22" height="80" rx="4" fill="#1e293b" stroke="#334155" strokeWidth="1.5"/>
                                  <rect x="107" y="66" width="10" height="28" rx="2" fill="#0f172a" stroke="#475569" strokeWidth="1"/>
                                  <rect x="109" y="70" width="6" height="6" rx="1" fill="#334155"/>
                                  <rect x="109" y="80" width="6" height="6" rx="1" fill="#334155"/>
                                  <g className="plug-group">
                                    <rect x="122" y="66" width="42" height="28" rx="4" fill="#22d3ee"/>
                                    <rect x="126" y="70" width="34" height="20" rx="2" fill="#0e7490"/>
                                    <rect x="131" y="74" width="6" height="5" rx="1" fill="#22d3ee" opacity="0.6"/>
                                    <rect x="141" y="74" width="6" height="5" rx="1" fill="#22d3ee" opacity="0.6"/>
                                    <rect x="131" y="82" width="6" height="4" rx="1" fill="#22d3ee" opacity="0.4"/>
                                    <rect x="141" y="82" width="6" height="4" rx="1" fill="#22d3ee" opacity="0.4"/>
                                    <rect x="164" y="72" width="8" height="16" rx="1" fill="#22d3ee"/>
                                    <rect x="172" y="58" width="64" height="44" rx="6" fill="#1e293b" stroke="#334155" strokeWidth="1.5"/>
                                    <rect x="176" y="70" width="56" height="20" rx="2" fill="#0f172a"/>
                                    <rect x="180" y="74" width="48" height="12" rx="2" fill="#111827"/>
                                    <path d="M236 80 C262 80 272 60 302 65 C332 70 342 90 372 88 C402 86 412 72 442 75 C472 78 482 88 512 85 C542 82 562 72 600 75 C630 78 650 82 680 78" stroke="#334155" strokeWidth="10" strokeLinecap="round" fill="none"/>
                                    <path d="M236 80 C262 80 272 60 302 65 C332 70 342 90 372 88 C402 86 412 72 442 75 C472 78 482 88 512 85 C542 82 562 72 600 75 C630 78 650 82 680 78" stroke="#22d3ee" strokeWidth="2.5" strokeLinecap="round" fill="none" strokeDasharray="8 8" className="flow"/>
                                  </g>
                                </svg>
                              </div>
                            )}
                            {i === 1 && (
                              <div className="mt-3 mx-1 rounded-lg overflow-hidden border border-slate-700/40 bg-slate-900/60 p-3 flex items-center gap-3">
                                {/* Phone */}
                                <div className="flex-shrink-0 rounded-xl overflow-hidden flex flex-col" style={{width:'72px',height:'120px',background:'#1a1a2e',border:'2px solid #444'}}>
                                  <div style={{height:'10px',background:'#111',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                    <div style={{width:'5px',height:'5px',borderRadius:'50%',background:'#333'}}/>
                                  </div>
                                  <div style={{flex:1,background:'#0f0f18',padding:'6px 5px',display:'flex',flexDirection:'column',gap:'3px'}}>
                                    <div style={{fontSize:'8px',color:'#666',textAlign:'center',marginBottom:'3px'}}>Wi-Fi</div>
                                    <div style={{display:'flex',alignItems:'center',gap:'3px',padding:'3px 4px',borderRadius:'3px',background:'#00d4ff18',border:'0.5px solid #00d4ff44'}}>
                                      <span style={{fontSize:'7px',color:'#00d4ff',flex:1}}>Digital Display</span>
                                      <div style={{width:'7px',height:'7px',borderRadius:'50%',background:'#00d4ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'5px',color:'#000'}}>✓</div>
                                    </div>
                                    <div style={{display:'flex',alignItems:'center',gap:'3px',padding:'3px 4px',borderRadius:'3px',background:'#ffffff08'}}>
                                      <span style={{fontSize:'7px',color:'#888',flex:1}}>Virgin Media 5G</span>
                                    </div>
                                    <div style={{display:'flex',alignItems:'center',gap:'3px',padding:'3px 4px',borderRadius:'3px',background:'#ffffff08'}}>
                                      <span style={{fontSize:'7px',color:'#888',flex:1}}>BT-Hub-5432</span>
                                    </div>
                                  </div>
                                </div>
                                {/* Arrow + callout */}
                                <div className="text-slate-600 text-base flex-shrink-0">→</div>
                                <div style={{flex:1,background:'#00d4ff12',border:'1px solid #00d4ff33',borderRadius:'8px',padding:'8px 10px'}}>
                                  <div style={{fontSize:'9px',color:'#00d4ff88',marginBottom:'4px'}}>Connect to:</div>
                                  <div style={{fontSize:'11px',color:'#22d3ee',fontFamily:'monospace',fontWeight:600}}>Digital Display</div>
                                  <div style={{fontSize:'9px',color:'#ffffff33',marginTop:'4px'}}>in Wi-Fi settings</div>
                                </div>
                              </div>
                            )}
                            {i === 2 && (
                              <div className="mt-3 mx-1 rounded-lg overflow-hidden border border-slate-700/40" style={{background:'#0f0f13'}}>
                                <div style={{background:'linear-gradient(135deg,#1a1a2e,#0f3460)',borderBottom:'1px solid #00d4ff22',padding:'7px 10px',display:'flex',alignItems:'center',gap:'8px'}}>
                                  <span style={{fontSize:'10px',fontWeight:500,color:'#00d4ff',letterSpacing:'0.5px'}}>Digital Display — Setup</span>
                                  <div style={{marginLeft:'auto',background:'#ffffff0d',border:'1px solid #00d4ff22',borderRadius:'3px',color:'#00d4ff',fontSize:'9px',padding:'2px 6px',fontFamily:'monospace'}}>192.168.4.1</div>
                                </div>
                                <div style={{display:'flex',gap:'10px',padding:'10px'}}>
                                  <div style={{flex:1}}>
                                    <div style={{fontSize:'9px',color:'#00d4ffaa',marginBottom:'5px'}}>Available networks</div>
                                    {['Virgin Media 5G','BT-Hub-5432 ✓','Sky-Hub-2A1B'].map((n,idx) => (
                                      <div key={idx} style={{display:'flex',alignItems:'center',gap:'5px',padding:'4px 6px',borderRadius:'4px',border:`0.5px solid ${idx===1?'#00d4ff66':'#ffffff12'}`,background:idx===1?'#00d4ff12':'#1e1e2e',marginBottom:'3px'}}>
                                        <span style={{fontSize:'9px',color:idx===1?'#00d4ff':'#888',flex:1}}>{n}</span>
                                      </div>
                                    ))}
                                  </div>
                                  <div style={{flex:1,display:'flex',flexDirection:'column',gap:'6px'}}>
                                    <div>
                                      <div style={{fontSize:'8px',color:'#00d4ffaa',marginBottom:'2px'}}>Wi-Fi password</div>
                                      <div style={{background:'#1e1e2e',border:'1px solid #00d4ff33',borderRadius:'3px',color:'#888',padding:'3px 6px',fontSize:'9px'}}>••••••••••</div>
                                    </div>
                                    <div>
                                      <div style={{fontSize:'8px',color:'#00d4ffaa',marginBottom:'2px'}}>Device name</div>
                                      <div style={{background:'#1e1e2e',border:'1px solid #00d4ff66',borderRadius:'3px',color:'#22d3ee',padding:'3px 6px',fontSize:'9px',fontFamily:'monospace'}}>My Stream Stand</div>
                                    </div>
                                    <div style={{background:'linear-gradient(135deg,#00d4ff,#7b2ff7)',borderRadius:'4px',padding:'4px 8px',textAlign:'center',fontSize:'9px',fontWeight:600,color:'#fff'}}>Complete &amp; Restart</div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {i === 3 && (
                              <div className="mt-3 mx-1 rounded-lg border border-slate-700/40 bg-slate-900/60 p-3 flex items-center justify-center">
                                <div className="flex flex-col items-center gap-2">
                                  <div style={{width:'148px',height:'64px',background:'#ffffff',borderRadius:'4px',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                    <div style={{textAlign:'center',fontFamily:'monospace'}}>
                                      <div style={{fontSize:'13px',fontWeight:700,color:'#1a1a1a'}}>✓ Success</div>
                                      <div style={{fontSize:'8px',color:'#444'}}>My Stream Stand</div>
                                      <div style={{fontSize:'10px',color:'#1a1a1a',fontWeight:600}}>192.168.1.50</div>
                                    </div>
                                  </div>
                                  <span style={{fontSize:'0.6rem',color:'#94a3b8'}}>Example IP Address</span>
                                </div>
                              </div>
                            )}
                            {i === 4 && (
                              <div className="mt-3 mx-1 rounded-lg overflow-hidden border border-slate-700/40 bg-slate-900/60 p-3 flex flex-col items-center gap-2">
                                <div className="relative overflow-hidden rounded-lg border border-slate-700/50" style={{width:'296px', height:'128px', background:'#0f172a'}}>
                                  {[1,2,3,4,5].map((n) => (
                                    <img
                                      key={n}
                                      src={`/display${n}.png`}
                                      alt={`Display example ${n}`}
                                      className="absolute inset-0 w-full h-full object-cover"
                                      style={{
                                        opacity: displayImageIndex === n - 1 ? 1 : 0,
                                        filter: 'url(#epaper)',
                                        transition: 'opacity 0.7s ease',
                                      }}
                                    />
                                  ))}
                                </div>
                                <span style={{fontSize:'0.6rem',color:'#94a3b8'}}>Push graphics, text, or a combination of both to your display from any device on your network</span>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                      {/* One-time note */}
                      <div className="mt-3 flex items-center gap-2 px-1">
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#4ade80" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        <p className="text-slate-500 text-[11px] leading-relaxed">You only need to do this once — next time you power on, your device will connect automatically. Just power on and visit your device IP.</p>
                      </div>

                      {/* Factory reset note */}
                      <div className="mt-2 flex items-center gap-2 px-1">
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#22d3ee" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0}}>
                          <circle cx="12" cy="12" r="10"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="12" y1="8" x2="12.01" y2="8"/>
                        </svg>
                        <p className="text-slate-500 text-[11px] leading-relaxed">To factory reset, hold the reset button whilst powering on for 5 seconds. This will clear your Wi-Fi settings and restart setup.</p>
                      </div>

                      {/* Troubleshooting */}
                      <div className="mt-2 px-1 pb-3">
                        <a href="https://pokebubble.com/docs" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 px-3 py-2 rounded-xl transition-all duration-150 active:scale-95" style={{background:'rgba(239,68,68,0.08)', border:'1px solid rgba(239,68,68,0.2)'}}>
                          <div className="w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0" style={{background:'rgba(239,68,68,0.15)'}}>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                              <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                            </svg>
                          </div>
                          <p className="text-slate-300 text-[11px] leading-relaxed">Need help using this device? Support is available via <span className="text-cyan-400">Discord</span>.</p>
                        </a>
                      </div>
                    </div>
                  </div>

                {/* Update Firmware bar */}
                <div className="border-t border-slate-700/50" />
                <div className="px-4 py-2 flex items-center justify-between cursor-pointer" onClick={() => { setExpandedFirmware(expandedFirmware === item.id ? null : item.id); setExpandedInstructions(null); }}>
                    <div className="flex items-center gap-3">
                      <div className="w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0" style={{background:'linear-gradient(135deg,#4ade80,#22c55e)'}}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/>
                        </svg>
                      </div>
                      <div className="w-px h-6 bg-slate-700/60 flex-shrink-0" />
                      <div>
                        <span className="text-xs font-semibold text-slate-300">Update Firmware</span>
                        <p className="text-slate-500 mt-0.5" style={{fontSize:'0.6rem'}}>Keep your device up to date with the latest features.</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="flex flex-col items-end gap-0.5">
                        <span className="font-mono" style={{fontSize:'0.55rem', color:'#4ade80'}}>Latest: {LATEST_VERSION}</span>
                        {deviceVersion && <span className="font-mono" style={{fontSize:'0.55rem', color:'#94a3b8'}}>{deviceName}: {deviceVersion}</span>}
                      </div>
                      <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-transform duration-300" style={{background:'linear-gradient(135deg,#4ade80,#22c55e)', transform: expandedFirmware === item.id ? 'rotate(90deg)' : 'rotate(0deg)'}}>
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="9 18 15 12 9 6"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="border-t border-slate-700/50" />

                  <div className={`instructions-body${expandedFirmware === item.id ? ' open' : ''}`}>
                    <div className="instructions-inner">
                      <div className="px-4 pt-4 pb-4">
                      <div className="rounded-xl border border-slate-700/40 overflow-hidden">

                        {/* State: unsupported */}
                        {firmwareState === 'unsupported' && (
                          <div className="px-4 py-4 flex flex-col gap-2">
                            <div className="flex items-center gap-2 p-3 rounded-lg" style={{background:'rgba(251,191,36,0.08)', border:'1px solid rgba(251,191,36,0.25)'}}>
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fbbf24" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
                              <div>
                                <p className="text-amber-400 text-xs font-semibold">Browser not supported</p>
                                <p className="text-slate-500 mt-0.5" style={{fontSize:'0.6rem'}}>Please use Chrome or Edge to use this feature.</p>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* State: disconnected */}
                        {firmwareState === 'disconnected' && (
                          <div className="px-4 py-4 flex flex-col gap-3">
                            <div className="flex items-center justify-between bg-slate-900/60 rounded-lg px-3 py-2">
                              <div className="flex items-center gap-2">
                                <div className="w-2 h-2 rounded-full bg-slate-600 flex-shrink-0"/>
                                <span className="text-slate-500 text-xs font-mono">Not connected</span>
                              </div>
                              <span className="text-slate-600 font-mono" style={{fontSize:'0.6rem'}}>Current: v1.2.4</span>
                            </div>
                            <div className="flex items-center gap-2 text-slate-500" style={{fontSize:'0.65rem'}}>
                              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                              Plug your stand into your computer via USB, then click connect.
                            </div>
                            <button
                              onClick={(e) => { e.stopPropagation(); connectSerial(); }}
                              className="w-full py-2 rounded-lg text-xs font-semibold text-white transition-all active:scale-95 flex items-center justify-center gap-2"
                              style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}
                            >
                              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                              Connect Device via USB
                            </button>
                          </div>
                        )}

                        {/* State: connecting */}
                        {firmwareState === 'connecting' && (
                          <div className="px-4 py-4 flex flex-col items-center gap-3">
                            <svg className="animate-spin" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#22d3ee" strokeWidth="2.5" strokeLinecap="round"><circle cx="12" cy="12" r="10" strokeOpacity="0.15"/><path d="M12 2a10 10 0 0 1 10 10"/></svg>
                            <div className="text-center">
                              <p className="text-slate-300 text-xs font-semibold">Connecting…</p>
                              <p className="text-slate-600 mt-0.5" style={{fontSize:'0.6rem'}}>Reading device info via serial</p>
                            </div>
                          </div>
                        )}

                        {/* State: connected */}
                        {firmwareState === 'connected' && (
                          <div className="px-4 py-4 flex flex-col gap-3">
                            <div className="flex items-center justify-between bg-slate-900/60 rounded-lg px-3 py-2.5">
                              <div className="flex items-center gap-2">
                                <div className="w-2 h-2 rounded-full bg-green-400" style={{boxShadow:'0 0 6px rgba(74,222,128,0.6)'}}/>
                                <span className="text-white text-xs font-semibold">{deviceName || 'Digital Display Stand'}</span>
                              </div>
                              <div className="text-right">
                                <p className="text-slate-500 font-mono" style={{fontSize:'0.6rem'}}>Digital Display Stand</p>
                                <p className="text-cyan-400 font-mono font-semibold" style={{fontSize:'0.6rem'}}>{deviceVersion || 'v1.0.0'}</p>
                              </div>
                            </div>
                            <button
                              onClick={(e) => { e.stopPropagation(); setFirmwareState('checking');
                                setTimeout(() => {
                                  const isLatest = deviceVersion === LATEST_VERSION;
                                  setFirmwareState(isLatest ? 'uptodate' : 'available');
                                }, 2000);
                              }}
                              className="w-full py-2 rounded-lg text-xs font-semibold text-white transition-all active:scale-95"
                              style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}
                            >Check for Updates</button>
                            <button onClick={(e) => { e.stopPropagation(); disconnectSerial(); }} className="text-slate-600 text-[10px] text-center w-full hover:text-slate-400 transition-colors">Disconnect</button>
                          </div>
                        )}

                        {/* State: checking */}
                        {firmwareState === 'checking' && (
                          <div className="px-4 py-4 flex flex-col items-center gap-3">
                            <svg className="animate-spin" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#22d3ee" strokeWidth="2.5" strokeLinecap="round"><circle cx="12" cy="12" r="10" strokeOpacity="0.15"/><path d="M12 2a10 10 0 0 1 10 10"/></svg>
                            <div className="text-center">
                              <p className="text-slate-300 text-xs font-semibold">Checking for updates…</p>
                              <p className="text-slate-600 mt-0.5" style={{fontSize:'0.6rem'}}>cheeks.uk/firmware/esp32c6</p>
                            </div>
                          </div>
                        )}

                        {/* State: up to date */}
                        {firmwareState === 'uptodate' && (
                          <div className="px-4 py-4 flex flex-col gap-3">
                            <div className="flex items-center gap-2 p-3 rounded-lg" style={{background:'rgba(74,222,128,0.08)', border:'1px solid rgba(74,222,128,0.2)'}}>
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4ade80" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                              <div>
                                <p className="text-green-400 text-xs font-semibold">Your firmware is up to date</p>
                                <p className="text-slate-500 mt-0.5" style={{fontSize:'0.6rem'}}>{LATEST_VERSION} — latest release</p>
                              </div>
                            </div>
                            <button onClick={(e) => { e.stopPropagation(); setFirmwareState('connected'); }} className="text-slate-600 text-[10px] text-center w-full hover:text-slate-400 transition-colors">Back</button>
                          </div>
                        )}

                        {/* State: update available */}
                        {firmwareState === 'available' && (
                          <div className="px-4 py-4 flex flex-col gap-3">
                            <div className="flex items-center gap-2 p-3 rounded-lg" style={{background:'rgba(34,211,238,0.06)', border:'1px solid rgba(34,211,238,0.2)'}}>
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#22d3ee" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="8 17 12 21 16 17"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.96"/></svg>
                              <div className="flex-1">
                                <p className="text-cyan-400 text-xs font-semibold">Update available — {LATEST_VERSION}</p>
                                <p className="text-slate-500 mt-0.5" style={{fontSize:'0.6rem'}}>Released 3 Apr 2026 · 284 KB</p>
                              </div>
                            </div>
                            <div className="text-slate-500 bg-slate-900/40 rounded-lg px-3 py-2" style={{fontSize:'0.6rem'}}>
                              <p className="text-slate-400 font-semibold mb-1">What's new in {LATEST_VERSION}</p>
                              <p>• Faster Wi-Fi reconnection on boot</p>
                              <p>• Stream Deck stability improvements</p>
                              <p>• Fixed rare display flicker on update</p>
                            </div>
                            <button
                              onClick={(e) => { e.stopPropagation(); runOTA(); }}
                              className="w-full py-2 rounded-lg text-xs font-semibold text-white transition-all active:scale-95"
                              style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}
                            >Install Update</button>
                            <button onClick={(e) => { e.stopPropagation(); setFirmwareState('connected'); }} className="text-slate-600 text-[10px] text-center w-full hover:text-slate-400 transition-colors">Cancel</button>
                          </div>
                        )}

                        {/* State: updating */}
                        {firmwareState === 'updating' && (
                          <div className="px-4 py-4 flex flex-col gap-3">
                            <div className="flex items-center justify-between">
                              <span className="text-slate-300 text-xs font-semibold">Installing {LATEST_VERSION}…</span>
                              <span className="text-cyan-400 font-mono text-xs">{Math.round(firmwareProgress)}%</span>
                            </div>
                            <div className="w-full h-2 rounded-full bg-slate-700/60 overflow-hidden">
                              <div className="h-full rounded-full transition-all duration-200" style={{width:`${firmwareProgress}%`, background:'linear-gradient(90deg,#22d3ee,#3b82f6)'}}/>
                            </div>
                            <p className="text-slate-600 text-[10px]">Do not unplug your device during this process.</p>
                          </div>
                        )}

                        {/* State: done */}
                        {firmwareState === 'done' && (
                          <div className="px-4 py-4 flex flex-col gap-3">
                            <div className="flex items-center gap-2 p-3 rounded-lg" style={{background:'rgba(74,222,128,0.08)', border:'1px solid rgba(74,222,128,0.2)'}}>
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4ade80" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                              <div>
                                <p className="text-green-400 text-xs font-semibold">Successfully updated to {LATEST_VERSION}</p>
                                <p className="text-slate-500 mt-0.5" style={{fontSize:'0.6rem'}}>Device is restarting — this may take a few seconds.</p>
                              </div>
                            </div>
                            <button onClick={(e) => { e.stopPropagation(); disconnectSerial(); }} className="text-slate-600 text-[10px] text-center w-full hover:text-slate-400 transition-colors">Done</button>
                          </div>
                        )}

                        {/* State: error */}
                        {firmwareState === 'error' && (
                          <div className="px-4 py-4 flex flex-col gap-3">
                            <div className="flex items-center gap-2 p-3 rounded-lg" style={{background:'rgba(251,113,133,0.08)', border:'1px solid rgba(251,113,133,0.2)'}}>
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fb7185" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                              <div>
                                <p className="text-rose-400 text-xs font-semibold">Update failed</p>
                                <p className="text-slate-500 mt-0.5" style={{fontSize:'0.6rem'}}>Check your device is connected to Wi-Fi and try again.</p>
                              </div>
                            </div>
                            <button onClick={(e) => { e.stopPropagation(); setFirmwareState('connected'); }} className="text-slate-600 text-[10px] text-center w-full hover:text-slate-400 transition-colors">Try again</button>
                          </div>
                        )}

                      </div>
                      {/* Discord firmware notification note */}
                      <div className="mt-3 px-1 pb-1">
                        <a href="https://pokebubble.com/docs" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 px-3 py-2 rounded-xl transition-all duration-150 active:scale-95" style={{background:'rgba(234,179,8,0.08)', border:'1px solid rgba(234,179,8,0.2)'}}>
                          <div className="w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0" style={{background:'rgba(234,179,8,0.15)'}}>
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#eab308" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{animation:'bellRing 2s ease-in-out infinite', transformOrigin:'top center'}}>
                              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                            </svg>
                          </div>
                          <p className="text-slate-300 text-[11px] leading-relaxed">Be notified on <span className="text-cyan-400">Discord</span> of the latest firmware updates.</p>
                        </a>
                      </div>
                    </div>
                  </div>
                  </div>

              </div>
            ))}

            {/* ── ADJUSTABLE STAND CARD ── */}
            <div className="creation-card bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] overflow-hidden">
              <div className="relative w-full overflow-hidden" style={{aspectRatio:'1/1', background:'radial-gradient(ellipse at 60% 50%, rgba(34,211,238,0.08) 0%, rgba(59,130,246,0.06) 40%, rgba(15,23,42,0.0) 70%)'}}>
                <div className="absolute inset-0" style={{backgroundImage:'linear-gradient(rgba(34,211,238,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(34,211,238,0.04) 1px, transparent 1px)', backgroundSize:'32px 32px', zIndex:0}} />
                <div className="absolute bottom-0 left-0 right-0 h-1/2" style={{background:'linear-gradient(to top, rgba(59,130,246,0.06), transparent)', zIndex:0}} />
                <img src="/stand_adjustable.jpeg" alt="Custom Card & Slab Stand (Adjustable)" className="w-full h-full object-cover" style={{position:'relative', zIndex:1}} />
                <div className="absolute top-3 right-3 flex items-center gap-1.5 px-2 py-1 rounded-md text-[10px] font-bold text-white" style={{background:'linear-gradient(135deg, #22d3ee, #3b82f6)'}}>
                  New
                </div>
              </div>
              <div className="px-4 pt-4 pb-3">
                <div className="flex items-center justify-between gap-2 mb-3">
                  <h2 className="text-white font-bold text-base leading-tight">Custom Card & Slab Stand (Adjustable)</h2>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="text-slate-500 text-[10px] leading-tight text-right">MOQ<br/><span className="text-slate-400 font-semibold">5 units</span></span>
                    <div className="flex items-center gap-1 px-2.5 py-1 rounded-full" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                      <span className="text-white font-semibold uppercase tracking-widest" style={{fontSize:'0.55rem'}}>From</span>
                      <span className="text-white font-bold text-base leading-tight">£19.99</span>
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 mb-3">
                  {['3D Printed','Adjustable Fit','All TCGs','Slab & Raw Cards','Custom Colours'].map((point) => (
                    <div key={point} className="flex items-center gap-1.5">
                      <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                        <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                      </div>
                      <span className="text-slate-300 font-medium" style={{fontSize:'0.7rem'}}>{point}</span>
                    </div>
                  ))}
                </div>
                <p className="text-slate-400 leading-relaxed mb-0" style={{fontSize:'0.75rem'}}>
                  A 3D printed display stand with an adjustable cradle to fit cards and slabs of varying sizes. Compatible with all major TCGs — Pokémon, MTG, Yu-Gi-Oh! and more. Print in your choice of filament colour to match your setup.
                </p>
              </div>
            </div>

            {/* ── FIXED STAND CARD ── */}
            <div className="creation-card bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] overflow-hidden">
              <div className="relative w-full overflow-hidden" style={{aspectRatio:'1/1', background:'radial-gradient(ellipse at 60% 50%, rgba(34,211,238,0.08) 0%, rgba(59,130,246,0.06) 40%, rgba(15,23,42,0.0) 70%)'}}>
                <div className="absolute inset-0" style={{backgroundImage:'linear-gradient(rgba(34,211,238,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(34,211,238,0.04) 1px, transparent 1px)', backgroundSize:'32px 32px', zIndex:0}} />
                <div className="absolute bottom-0 left-0 right-0 h-1/2" style={{background:'linear-gradient(to top, rgba(59,130,246,0.06), transparent)', zIndex:0}} />
                <img src="/stand_fixed.jpeg" alt="Custom Card & Slab Stand (Fixed)" className="w-full h-full object-cover" style={{position:'relative', zIndex:1}} />
                <div className="absolute top-3 right-3 flex items-center gap-1.5 px-2 py-1 rounded-md text-[10px] font-bold text-white" style={{background:'linear-gradient(135deg, #22d3ee, #3b82f6)'}}>
                  New
                </div>
              </div>
              <div className="px-4 pt-4 pb-3">
                <div className="flex items-center justify-between gap-2 mb-3">
                  <h2 className="text-white font-bold text-base leading-tight">Custom Card & Slab Stand (Fixed)</h2>
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="text-slate-500 text-[10px] leading-tight text-right">MOQ<br/><span className="text-slate-400 font-semibold">10 units</span></span>
                    <div className="flex items-center gap-1 px-2.5 py-1 rounded-full" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                      <span className="text-white font-semibold uppercase tracking-widest" style={{fontSize:'0.55rem'}}>From</span>
                      <span className="text-white font-bold text-base leading-tight">£14.99</span>
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 mb-3">
                  {['3D Printed','Fixed Cradle','All TCGs','Slab & Raw Cards','Custom Colours'].map((point) => (
                    <div key={point} className="flex items-center gap-1.5">
                      <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                        <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                      </div>
                      <span className="text-slate-300 font-medium" style={{fontSize:'0.7rem'}}>{point}</span>
                    </div>
                  ))}
                </div>
                <p className="text-slate-400 leading-relaxed mb-0" style={{fontSize:'0.75rem'}}>
                  A clean, minimal 3D printed display stand with a fixed cradle — perfectly sized for your cards or slabs. Solid, sturdy and simple. Compatible with all major TCGs and available in any filament colour you like.
                </p>
              </div>
            </div>

            {/* ── RUGGED BOX CARD ── */}
            <div className="creation-card bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-2xl shadow-[0_6px_24px_rgba(0,0,0,0.4)] overflow-hidden">

              {/* Product image */}
              <div className="relative w-full overflow-hidden" style={{aspectRatio:'4/3'}}>
                <img
                  src="/ruggedbox.jpg"
                  alt="Semi Rigid Card Sleeve Rugged Box"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 right-3 flex items-center gap-1.5 px-2 py-1 rounded-md text-[10px] font-bold text-white" style={{background:'linear-gradient(135deg, #22d3ee, #3b82f6)'}}>
                  Free Model
                </div>
              </div>

              {/* Info block */}
              <div className="px-4 pt-4 pb-3">
                <div className="flex items-center justify-between gap-2 mb-3">
                  <h2 className="text-white font-bold text-base leading-tight">Semi Rigid Card Sleeve Rugged Box</h2>
                  <div className="flex-shrink-0 flex items-center gap-1 px-2.5 py-1 rounded-full" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                    <span className="text-white font-bold text-base leading-tight">FREE</span>
                  </div>
                </div>

                {/* Feature pills */}
                <div className="flex flex-wrap gap-2 mb-3">
                  {[
                    'Free 3D Print',
                    '100–120 Cards',
                    'Semi Rigid Sleeves',
                    'PLA or PETG',
                    'Snap-Shut Lid',
                  ].map((point) => (
                    <div key={point} className="flex items-center gap-1.5">
                      <div className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                        <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                      </div>
                      <span className="text-slate-300 font-medium" style={{fontSize:'0.7rem'}}>{point}</span>
                    </div>
                  ))}
                </div>

                {/* Description */}
                <p className="text-slate-400 leading-relaxed mb-4" style={{fontSize:'0.75rem'}}>
                  Designed to fit semi rigid sleeves perfectly and holds 100–120 sleeved cards. Prints well in PLA, PLA Matte or PETG if you want a bit more durability. Secure the lid with M3 screws and locking fasteners, or use 3mm rod / filament pins instead. Just avoid matte filament for the pins — they're prone to snapping.
                </p>

              </div>

              {/* MakerWorld download bar */}
              <div className="border-t border-slate-700/50" />
              <a
                href="https://makerworld.com/en/models/1573714-semi-rigid-card-sleeve-rugged-box"
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 flex items-center justify-between"
              >
                <div className="flex items-center gap-3">
                  <div className="w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0" style={{background:'linear-gradient(135deg,#4ade80,#22c55e)'}}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
                    </svg>
                  </div>
                  <div className="w-px h-6 bg-slate-700/60 flex-shrink-0" />
                  <div>
                    <span className="text-xs font-semibold text-slate-300">Download FREE on MakerWorld</span>
                    <p className="text-slate-500 mt-0.5" style={{fontSize:'0.6rem'}}>Get the free 3D print file for this model.</p>
                  </div>
                </div>
                <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0" style={{background:'linear-gradient(135deg,#4ade80,#22c55e)'}}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </div>
              </a>
              <div className="border-t border-slate-700/50" />
            </div>

            {/* More creations coming soon */}
            <div className="flex items-center gap-3 bg-slate-800/40 border border-slate-700/40 rounded-2xl px-4 py-2">
              <div className="w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                <img src="/pball.svg" alt="" className="h-4 w-4 animate-spin" style={{animationDuration:"2s", filter:"brightness(0) invert(1)"}} />
              </div>
              <div className="w-px h-6 bg-slate-700/60 flex-shrink-0" />
              <div>
                <p className="text-slate-300 text-xs font-semibold leading-none">More creations on the way</p>
                <p className="text-slate-500 text-[10px] mt-0.5 leading-none">New products are being added to this page shortly.</p>
              </div>
            </div>

          </div>
        </div>
        </main>
      )}

      {/* ══════════════════════════════════════════
          BATTLE TAB
      ══════════════════════════════════════════ */}
      {/* ══════════════════════════════════════════
          CARD BUILDER TAB
      ══════════════════════════════════════════ */}
      {activeTab === 'builder' && (
        <main className="flex-1">
          <div className="max-w-5xl mx-auto px-4 py-6">

            {/* Info bar */}
            <div className="flex items-center gap-3 bg-slate-800/40 border border-slate-700/40 rounded-2xl px-4 py-2 mb-5">
              <div className="w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0" style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}>
                <img src="/pball.svg" alt="" className="h-4 w-4 animate-spin" style={{animationDuration:'2s', filter:'brightness(0) invert(1)'}} />
              </div>
              <div className="w-px h-6 bg-slate-700/60 flex-shrink-0" />
              <div>
                <p className="text-slate-300 text-xs font-semibold leading-none">Design your own custom card</p>
                <p className="text-slate-500 text-[10px] mt-0.5 leading-none">Made live by CHEEKS on Whatnot</p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">

              {/* ── Live preview ── */}
              <div className="flex flex-col items-center gap-3 lg:sticky lg:top-24">
                <style>{`
                  @keyframes cardIdleSheen {
                    0%, 100% { background-position: 0% 50%; }
                    50%      { background-position: 100% 50%; }
                  }
                  .builder-card-sheen {
                    background-image: repeating-linear-gradient(115deg,
                      rgba(255,255,255,0) 0%, rgba(255,255,255,0.55) 3%, rgba(255,255,255,0) 6%,
                      rgba(255,255,255,0) 30%, rgba(255,255,255,0.4) 34%, rgba(255,255,255,0) 38%);
                    background-size: 250% 250%;
                    animation: cardIdleSheen 5s ease-in-out infinite;
                    mix-blend-mode: overlay;
                  }
                `}</style>
                <div style={{ perspective: '900px' }}>
                  <div
                    onMouseMove={handleBuilderCardMouseMove}
                    onMouseLeave={handleBuilderCardMouseLeave}
                    className="relative w-full"
                    style={{
                      width: 'min(78vw, 300px)',
                      aspectRatio: '5/7',
                      borderRadius: '18px',
                      transform: `rotateX(${builderTilt.rx}deg) rotateY(${builderTilt.ry}deg) scale(${builderTilt.active ? 1.035 : 1})`,
                      transition: builderTilt.active ? 'transform 0.06s linear, box-shadow 0.2s ease' : 'transform 0.6s cubic-bezier(0.23,1,0.32,1), box-shadow 0.4s ease',
                      boxShadow: builderTilt.active
                        ? `${-builderTilt.ry * 1.2}px ${builderTilt.rx * 1.2 + 18}px 34px -10px rgba(0,0,0,0.55), 0 0 26px ${selectedBuilderType.color}66`
                        : '0 14px 28px -10px rgba(0,0,0,0.55)',
                      // White outer frame — same across every type/theme
                      background: `radial-gradient(circle at 28% 18%, rgba(255,255,255,0.5), transparent 55%), linear-gradient(160deg, rgba(0,0,0,0.15), transparent 65%), #ffffff`,
                      padding: '7px',
                    }}
                  >
                    {/* Inner card body */}
                    <div className="relative w-full h-full rounded-[12px] overflow-hidden flex flex-col" style={{ background: selectedBuilderBackground.gradient }}>

                      {/* Holo overlays */}
                      <div className="absolute inset-0 pointer-events-none builder-card-sheen" style={{ opacity: builderTilt.active ? 0.15 : 0.55 }} />
                      <div
                        className="absolute inset-0 pointer-events-none"
                        style={{
                          background: `radial-gradient(circle at ${builderTilt.mx}% ${builderTilt.my}%, rgba(255,255,255,0.85), transparent 45%)`,
                          mixBlendMode: 'overlay',
                          opacity: builderTilt.active ? 0.9 : 0,
                          transition: 'opacity 0.25s ease',
                        }}
                      />
                      <div
                        className="absolute inset-0 pointer-events-none"
                        style={{
                          backgroundImage: 'repeating-linear-gradient(115deg, #ff8a8a 0%, #ffe38a 12%, #8affab 24%, #8adfff 36%, #c28aff 48%, #ff8a8a 60%)',
                          backgroundSize: '220% 220%',
                          backgroundPosition: `${builderTilt.mx}% ${builderTilt.my}%`,
                          mixBlendMode: 'color-dodge',
                          opacity: builderTilt.active ? 0.4 : 0,
                          transition: 'opacity 0.25s ease',
                        }}
                      />

                      {/* Content */}
                      <div className="relative flex flex-col h-full px-2.5 pt-2 pb-2" style={{ fontFamily: "'Barlow Condensed', 'Arial Narrow', sans-serif" }}>

                        {/* Stage pill */}
                        <div className="flex items-center justify-between">
                          <span
                            className="font-bold uppercase text-slate-900/70"
                            style={{ fontSize: '0.42rem', letterSpacing: '0.1em', background: 'rgba(255,255,255,0.5)', borderRadius: '999px', padding: '1.5px 6px' }}
                          >
                            Basic
                          </span>
                          <span
                            className="font-bold text-slate-900"
                            style={{ fontSize: '0.5rem', letterSpacing: '0.08em', background: 'rgba(255,255,255,0.5)', borderRadius: '999px', padding: '1.5px 6px' }}
                          >
                            {selectedBuilderType.id.toUpperCase()} TYPE
                          </span>
                        </div>

                        {/* Name + HP row */}
                        <div className="flex items-center justify-between gap-1.5 mt-1">
                          <span
                            className="font-extrabold text-slate-900 truncate flex-1 min-w-0"
                            style={{
                              fontSize: '1.1rem',
                              letterSpacing: '-0.01em',
                              textShadow: '0.5px 0.5px 0 rgba(255,255,255,0.5), -0.5px 0 0 rgba(15,23,42,0.25), 0 1.5px 1px rgba(0,0,0,0.2)',
                            }}
                          >
                            {builderCardName || 'Card Name'}
                          </span>
                          <span className="flex items-center gap-1 flex-shrink-0 font-extrabold text-slate-900 ml-auto" style={{ fontSize: '1rem' }}>
                            <span style={{ fontSize: '0.65em' }}>HP</span>
                            <span style={{ fontSize: '1em', lineHeight: 1 }}>{builderHp || '0'}</span>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="white" style={{ flexShrink: 0, filter: 'drop-shadow(0 1px 1px rgba(0,0,0,0.35))' }}>
                              <circle cx="12" cy="12" r="11" fill={selectedBuilderType.color} stroke="rgba(0,0,0,0.3)" strokeWidth="0.75" />
                              {typeIconGlyph(selectedBuilderType.id)}
                            </svg>
                          </span>
                        </div>

                        {/* Character artwork — scene art (if picked) fills just this box, behind the Pokémon */}
                        <div
                          className="relative mt-1.5 flex-1 rounded-lg overflow-hidden flex items-center justify-center"
                          style={{
                            background: builderScene === 'none' ? 'radial-gradient(circle at 50% 30%, rgba(255,255,255,0.18), rgba(15,23,42,0.35) 70%)' : undefined,
                          }}
                        >
                          {builderScene !== 'none' && (
                            <>
                              <div className="absolute inset-0">{sceneArt(builderScene)}</div>
                              <div className="absolute inset-0" style={{ background: 'radial-gradient(circle at 50% 30%, rgba(255,255,255,0.06), rgba(15,23,42,0.3) 78%)' }} />
                            </>
                          )}
                          {/* Inner border/shadow frame — its own layer so it always sits above any scene art; rounded to match the box */}
                          <div className="absolute inset-0 rounded-lg pointer-events-none" style={{ boxShadow: 'inset 0 0 0 1.5px rgba(255,255,255,0.5), inset 0 6px 14px rgba(0,0,0,0.3)' }} />
                          {builderSelectedPokemon ? (
                            <img
                              src={pokemonSpriteUrl(builderSelectedPokemon.id)}
                              alt={builderSelectedPokemon.name}
                              className="w-full h-full object-contain p-2"
                              style={{ filter: 'drop-shadow(0 6px 10px rgba(0,0,0,0.45))' }}
                              draggable={false}
                            />
                          ) : (
                            <div className="flex flex-col items-center gap-2 opacity-60">
                              <img src="/pball.svg" alt="" className="h-8 w-8 animate-spin" style={{ animationDuration: '2s' }} />
                              <span className="text-white font-semibold" style={{ fontSize: '0.65rem' }}>Select a Pokémon</span>
                            </div>
                          )}
                        </div>

                        {/* Attack row — text stacks on the left, damage sits big & vertically centered on the right */}
                        <div className="mt-1.5 rounded-lg px-2.5 py-2 flex items-center gap-2" style={{ background: 'rgba(255,255,255,0.9)', boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.06)' }}>
                          <div className="flex-1 min-w-0 flex flex-col justify-center gap-0.5">
                            <div className="flex items-center gap-1.5 min-w-0">
                              <svg width="17" height="17" viewBox="0 0 24 24" fill="white" className="flex-shrink-0">
                                <circle cx="12" cy="12" r="11" fill={selectedBuilderType.color} stroke="rgba(0,0,0,0.25)" strokeWidth="0.75" />
                                {typeIconGlyph(selectedBuilderType.id)}
                              </svg>
                              <span className="font-extrabold text-slate-900 truncate" style={{ fontSize: '1rem' }}>{builderMoveName || 'Move Name'}</span>
                            </div>
                            <p className="text-slate-800 font-medium leading-snug" style={{ fontSize: '0.78rem' }}>
                              {builderMoveDesc || 'Move description goes here.'}
                            </p>
                          </div>
                          <span
                            className="font-extrabold text-slate-900 flex-shrink-0 text-right"
                            style={{ fontSize: '1.4rem', lineHeight: 1, textShadow: '0 1px 0 rgba(255,255,255,0.4)' }}
                          >
                            {builderMoveName ? builderDisplayDamage : ''}
                          </span>
                        </div>

                        {/* Card number footer */}
                        <div className="flex items-center justify-end mt-1.5 px-0.5">
                          <span className="font-semibold text-white/80" style={{ fontSize: '0.48rem', textShadow: '0 1px 2px rgba(0,0,0,0.5)' }}>{builderDisplayCardNumber}</span>
                        </div>

                        {/* Footer watermark */}
                        <p className="text-center mt-0.5 font-semibold text-white/70" style={{ fontSize: '0.42rem', letterSpacing: '0.1em', textShadow: '0 1px 2px rgba(0,0,0,0.5)' }}>
                          © CHEEKS 2026
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="text-slate-500 text-[10px]">Tilt with your cursor · updates live as you design</p>
              </div>

              {/* ── Controls ── */}
              <div className="flex flex-col gap-5">

                {/* Scene picker */}
                <div>
                  <label className="text-slate-300 text-xs font-semibold block mb-2">Background scene</label>
                  <div className="grid grid-cols-5 gap-2">
                    {cardScenes.map(scene => (
                      <button
                        key={scene.id}
                        onClick={() => setBuilderScene(scene.id)}
                        className="rounded-lg overflow-hidden border-2 transition-all duration-150 flex flex-col items-center"
                        style={{
                          borderColor: builderScene === scene.id ? '#22d3ee' : 'rgba(51,65,85,0.6)',
                          boxShadow: builderScene === scene.id ? '0 0 0 2px rgba(34,211,238,0.3)' : 'none',
                        }}
                      >
                        <div className="relative w-full overflow-hidden" style={{ height: '32px', background: selectedBuilderBackground.gradient }}>
                          {scene.id !== 'none' && sceneArt(scene.id)}
                        </div>
                        <span className="text-[8px] font-semibold text-slate-300 py-1 truncate px-0.5">{scene.name}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Pokemon picker */}
                <div className="relative" data-pokemon-picker>
                  <label className="text-slate-300 text-xs font-semibold block mb-2">Character (Pokémon)</label>
                  <div className="relative">
                    <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 h-4 w-4" />
                    <input
                      type="text"
                      placeholder={builderSelectedPokemon ? builderSelectedPokemon.name : 'Search for a Pokémon…'}
                      value={builderPokemonSearch}
                      onChange={(e) => { setBuilderPokemonSearch(e.target.value); setBuilderShowPokemonPicker(true); }}
                      onFocus={() => setBuilderShowPokemonPicker(true)}
                      className="pl-9 pr-3 py-2.5 bg-slate-700/50 border border-slate-600 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent w-full text-white placeholder-slate-500 text-sm transition-all duration-200"
                    />
                  </div>
                  {builderSelectedPokemon && (
                    <div className="flex items-center gap-2 mt-2 bg-slate-800/60 border border-slate-700/50 rounded-lg px-2.5 py-1.5">
                      <img src={pokemonSpriteUrl(builderSelectedPokemon.id)} alt="" className="h-6 w-6 object-contain" />
                      <span className="text-white text-xs font-semibold capitalize">{builderSelectedPokemon.name}</span>
                    </div>
                  )}
                  {builderSelectedPokemon && builderSelectedPokemon.id !== 'togecheeks' && (
                    <div className="flex items-center gap-1.5 mt-2">
                      {spriteStyles.map(style => (
                        <button
                          key={style.id}
                          onClick={() => setBuilderSpriteStyle(style.id)}
                          className="flex-1 rounded-md py-1 text-[10px] font-semibold transition-all duration-150"
                          style={{
                            background: builderSpriteStyle === style.id ? 'linear-gradient(135deg,#22d3ee,#3b82f6)' : 'rgba(51,65,85,0.5)',
                            color: builderSpriteStyle === style.id ? 'white' : 'rgba(148,163,184,0.9)',
                          }}
                        >
                          {style.name}
                        </button>
                      ))}
                    </div>
                  )}
                  {builderShowPokemonPicker && builderPokemonSearch.trim() && (
                    <div className="absolute z-20 mt-1 w-full max-h-56 overflow-y-auto bg-slate-800 border border-slate-700 rounded-xl shadow-xl">
                      {filteredBuilderPokemon.length > 0 ? (
                        filteredBuilderPokemon.map(p => (
                          <button
                            key={p.id}
                            onClick={() => {
                              setBuilderSelectedPokemon(p);
                              setBuilderPokemonSearch('');
                              setBuilderShowPokemonPicker(false);
                            }}
                            className="w-full flex items-center gap-2 px-3 py-2 hover:bg-slate-700/60 transition-colors text-left"
                          >
                            <img src={pokemonSpriteUrl(p.id)} alt="" className="h-7 w-7 object-contain flex-shrink-0" />
                            <span className="text-white text-xs font-medium capitalize">{p.name}</span>
                          </button>
                        ))
                      ) : (
                        <p className="text-slate-500 text-xs px-3 py-2.5">No matches — try another name.</p>
                      )}
                    </div>
                  )}
                </div>

                {/* Text fields */}
                <div className="grid grid-cols-2 gap-3">
                  <div className="col-span-2">
                    <label className="text-slate-300 text-xs font-semibold block mb-1.5">Card name</label>
                    <input
                      type="text"
                      maxLength={20}
                      value={builderCardName}
                      onChange={(e) => setBuilderCardName(e.target.value)}
                      placeholder="e.g. Pikachu"
                      className="px-3 py-2 bg-slate-700/50 border border-slate-600 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent w-full text-white placeholder-slate-500 text-sm"
                    />
                  </div>
                  <div>
                    <label className="text-slate-300 text-xs font-semibold block mb-1.5">HP</label>
                    <input
                      type="text"
                      inputMode="numeric"
                      maxLength={3}
                      value={builderHp}
                      onChange={(e) => setBuilderHp(e.target.value.replace(/[^0-9]/g, ''))}
                      className="px-3 py-2 bg-slate-700/50 border border-slate-600 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent w-full text-white placeholder-slate-500 text-sm"
                    />
                  </div>
                  <div>
                    <label className="text-slate-300 text-xs font-semibold block mb-1.5">Type</label>
                    <select
                      value={builderType}
                      onChange={(e) => setBuilderType(e.target.value)}
                      className="px-3 py-2 bg-slate-700/50 border border-slate-600 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent w-full text-white text-sm"
                    >
                      {cardTypes.map(t => <option key={t.id} value={t.id}>{t.id}</option>)}
                    </select>
                  </div>
                  <div className="col-span-2">
                    <label className="text-slate-300 text-xs font-semibold block mb-1.5">Move name</label>
                    <input
                      type="text"
                      maxLength={24}
                      value={builderMoveName}
                      onChange={(e) => setBuilderMoveName(e.target.value)}
                      placeholder="e.g. Thunderbolt"
                      className="px-3 py-2 bg-slate-700/50 border border-slate-600 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent w-full text-white placeholder-slate-500 text-sm"
                    />
                  </div>
                  <div className="col-span-2">
                    <label className="text-slate-300 text-xs font-semibold block mb-1.5">Move description</label>
                    <textarea
                      maxLength={90}
                      rows={2}
                      value={builderMoveDesc}
                      onChange={(e) => setBuilderMoveDesc(e.target.value)}
                      placeholder="e.g. Deals 90 damage to the opposing Pokémon."
                      className="px-3 py-2 bg-slate-700/50 border border-slate-600 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent w-full text-white placeholder-slate-500 text-sm resize-none"
                    />
                  </div>
                  <div>
                    <label className="text-slate-300 text-xs font-semibold block mb-1.5">Damage</label>
                    <input
                      type="text"
                      inputMode="numeric"
                      maxLength={3}
                      value={builderDamage}
                      onChange={(e) => setBuilderDamage(e.target.value.replace(/[^0-9]/g, ''))}
                      placeholder={String(builderAutoDamage)}
                      className="px-3 py-2 bg-slate-700/50 border border-slate-600 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent w-full text-white placeholder-slate-500 text-sm"
                    />
                  </div>
                  <div>
                    <label className="text-slate-300 text-xs font-semibold block mb-1.5">Card number</label>
                    <input
                      type="text"
                      maxLength={10}
                      value={builderCardNumberInput}
                      onChange={(e) => setBuilderCardNumberInput(e.target.value)}
                      placeholder={builderAutoCardNumber}
                      className="px-3 py-2 bg-slate-700/50 border border-slate-600 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent w-full text-white placeholder-slate-500 text-sm"
                    />
                  </div>
                </div>

                {/* Design code */}
                <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl p-3.5">
                  <p className="text-slate-300 text-xs font-semibold mb-2">Your design code</p>
                  {builderCode ? (
                    <>
                      <div className="flex items-center gap-2">
                        <code className="flex-1 bg-slate-900/70 border border-slate-700/50 rounded-lg px-2.5 py-2 text-cyan-300 text-xs break-all">{builderCode}</code>
                        <button
                          onClick={handleCopyBuilderCode}
                          className="flex items-center justify-center flex-shrink-0 rounded-lg transition-all duration-150 active:scale-95"
                          style={{width:'36px', height:'36px', background: builderCodeCopied ? 'linear-gradient(135deg,#22c55e,#16a34a)' : 'linear-gradient(135deg,#22d3ee,#3b82f6)'}}
                          title="Copy code"
                        >
                          {builderCodeCopied ? <Check className="h-4 w-4 text-white" /> : <Copy className="h-4 w-4 text-white" />}
                        </button>
                      </div>
                      <p className="text-slate-500 text-[10px] mt-2 leading-snug">This code always rebuilds this exact design — send it to CHEEKS to have it made live on Whatnot.</p>
                    </>
                  ) : (
                    <p className="text-slate-500 text-xs">Pick a Pokémon and enter a card name to generate your code.</p>
                  )}
                </div>

                {/* Load a code */}
                <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl p-3.5">
                  <p className="text-slate-300 text-xs font-semibold mb-2">Already have a code?</p>
                  <div className="flex items-center gap-2">
                    <input
                      type="text"
                      value={builderLoadCodeInput}
                      onChange={(e) => { setBuilderLoadCodeInput(e.target.value); setBuilderLoadCodeError(''); }}
                      placeholder="Paste your design code…"
                      className="flex-1 px-3 py-2 bg-slate-700/50 border border-slate-600 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent w-full text-white placeholder-slate-500 text-xs"
                    />
                    <button
                      onClick={handleLoadBuilderCode}
                      disabled={!builderLoadCodeInput.trim()}
                      className="flex-shrink-0 px-3.5 py-2 rounded-lg text-white text-xs font-semibold transition-all duration-150 active:scale-95 disabled:opacity-40"
                      style={{background:'linear-gradient(135deg,#22d3ee,#3b82f6)'}}
                    >
                      Load
                    </button>
                  </div>
                  {builderLoadCodeError && (
                    <p className="text-red-400 text-[10px] mt-2">{builderLoadCodeError}</p>
                  )}
                </div>

              </div>
            </div>
          </div>
        </main>
      )}

      {activeTab === 'battle' && (
        <main className="flex-1">
          <BattleArena
            database={database}
            discordUser={discordUser}
          />
        </main>
      )}

      {/* ── INVENTORY LIGHTBOX ── */}
      {selectedInventoryImage && (
        <div
          className="fixed inset-0 z-[400] flex items-center justify-center p-4"
          style={{background:'rgba(0,0,0,0.85)', backdropFilter:'blur(8px)', animation:'fadeInBackdrop 0.25s ease forwards'}}
          onClick={() => setSelectedInventoryImage(null)}
        >
          <style>{`
            @keyframes fadeInBackdrop {
              from { opacity: 0; }
              to   { opacity: 1; }
            }
            @keyframes popInCard {
              from { opacity: 0; transform: scale(0.92) translateY(16px); }
              to   { opacity: 1; transform: scale(1) translateY(0); }
            }
          `}</style>
          <div
            className="relative w-full max-w-lg rounded-2xl overflow-hidden shadow-2xl border border-slate-700/50"
            style={{background:'#0f172a', animation:'popInCard 0.3s cubic-bezier(0.34,1.56,0.64,1) forwards'}}
            onClick={e => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              onClick={() => setSelectedInventoryImage(null)}
              className="absolute top-3 right-3 z-10 w-8 h-8 rounded-full flex items-center justify-center text-slate-400 hover:text-white transition-colors"
              style={{background:'rgba(15,23,42,0.9)', border:'1px solid rgba(51,65,85,0.6)'}}
            >
              <X className="h-4 w-4" />
            </button>

            {/* Image */}
            <div className="relative w-full" style={{aspectRatio:'1/1'}}>
              <img
                src={`/${selectedInventoryImage.folder}/${selectedInventoryImage.filename}`}
                alt={selectedInventoryImage.name}
                className="w-full h-full object-contain"
              />
              {/* Grade badge */}
              {selectedInventoryImage.grade && (
                <div className="absolute top-3 left-3 bg-gradient-to-r from-cyan-500 to-blue-600 text-white px-2.5 py-1 rounded-md text-xs font-bold shadow-lg border border-cyan-400/50">
                  {selectedInventoryImage.grade}
                </div>
              )}
              {selectedInventoryImage.serial && (
                <div className="absolute bottom-3 left-3 text-white font-bold tracking-widest shadow-lg" style={{fontSize:'0.7rem', background:'rgba(0,0,0,0.4)', backdropFilter:'blur(4px)', border:'1px solid rgba(255,255,255,0.15)', borderRadius:'6px', padding:'3px 8px', letterSpacing:'0.1em'}}>
                  {selectedInventoryImage.serial}
                </div>
              )}
            </div>

            {/* Info */}
            <div className="px-4 py-3 border-t border-slate-700/50 flex items-center justify-between gap-3">
              <div className="flex-1 min-w-0">
                <h3 className="text-white font-bold text-sm leading-tight">{selectedInventoryImage.name}</h3>
                {selectedInventoryImage.set.split('  ').map((line, idx) => (
                  <p key={idx} className="text-slate-400 text-xs mt-0.5 leading-tight">{line}</p>
                ))}
              </div>
              {selectedInventoryImage.filename.includes('Crystal Palace') && (
                <img src="/cpfc.png" alt="CPFC" style={{width:'52px', height:'52px', objectFit:'contain', flexShrink:0}} />
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── FOOTER ── */}
      <footer className="bg-slate-800/80 backdrop-blur-lg border-t border-slate-700/50">
        <div className="max-w-7xl mx-auto px-6 py-3">
          <div className="flex flex-col items-center gap-2">
            <div className="flex items-center justify-center gap-3">
              <button onClick={() => setShowVideoModal(true)} className="group">
                <img src="/wnlogo.png" alt="Whatnot" className="h-6 w-6 object-contain opacity-50 group-hover:opacity-100 transition-opacity duration-200" />
              </button>
              <a href="https://pokebubble.com/docs" className="group">
                <img src="/discord.png" alt="Discord" className="h-6 w-6 object-contain opacity-50 group-hover:opacity-100 transition-opacity duration-200" />
              </a>
              <a href="https://www.instagram.com/togecheeks" target="_blank" rel="noopener noreferrer" className="group">
                <img src="/instagram.png" alt="Instagram" className="h-6 w-6 object-contain opacity-50 group-hover:opacity-100 transition-opacity duration-200" />
              </a>
            </div>
            <span className="text-slate-600 text-xs">© 2026 Cheeks / Cheeky Cards</span>
          </div>
        </div>
      </footer>

      {/* ── WHATNOT VIDEO MODAL ── */}
      {showVideoModal && (
        <div className="fixed inset-0 flex items-center justify-center p-4 z-[200] pointer-events-none">
          <div className="relative bg-slate-800/95 backdrop-blur-xl rounded-2xl w-full max-w-md max-h-[95vh] overflow-hidden border border-slate-700/50 shadow-2xl shadow-black/50 pointer-events-auto">
            <button
              onClick={handleVideoModalClose}
              className="absolute top-4 right-4 z-10 w-10 h-10 bg-slate-700/80 hover:bg-slate-600/80 text-slate-300 hover:text-white rounded-full flex items-center justify-center transition-colors duration-200 backdrop-blur-sm border border-slate-600/50"
            >
              <X className="h-5 w-5" />
            </button>
            <div className="relative w-full overflow-hidden" style={{ aspectRatio: '9/16', maxHeight: 'min(80vh, 700px)' }}>
              <video
                src="/splash.mp4"
                autoPlay
                muted
                preload="auto"
                onEnded={handleVideoEnd}
                className="w-full h-full rounded-2xl object-cover"
              >
                Your browser does not support the video tag.
              </video>
              <div className={`absolute top-6 left-4 right-4 flex justify-center transition-all duration-1000 ease-out ${videoEnded ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}>
                <div className="bg-white rounded-2xl overflow-hidden shadow-2xl w-full max-w-sm">
                  {/* Banner image with stats bar overlaid at bottom, right-aligned so avatar doesn't hide them */}
                  <div className="relative h-36 overflow-hidden">
                    <img src="https://rare-gallery.com/uploads/posts/1066121-illustration-anime-text-logo-cartoon-Pok-mon-Togepi-brand-ishmam-computer-wallpaper-font-organ.png" alt="Banner" className="w-full h-full object-cover object-center" />
                    {/* Stats bar pinned to bottom-right */}
                    <div className="absolute bottom-0 left-0 right-0 bg-black/80 px-3 py-1.5 flex items-center justify-end gap-3">
                      <span className="flex items-center gap-1 text-white text-xs font-semibold"><span className="text-yellow-400">★</span>5.0</span>
                      <span className="text-white/30">|</span>
                      <span className="text-white/60 text-xs">Reviews <span className="text-white font-semibold">182</span></span>
                      <span className="text-white/30">|</span>
                      <span className="text-white/60 text-xs">Sold <span className="text-white font-semibold">1.6k</span></span>
                    </div>
                  </div>
                  {/* Avatar sitting on the border between banner and white, not clipped by overflow-hidden */}
                  <div className="relative px-4">
                    <div className="absolute -top-7 left-4 w-14 h-14 rounded-full border-[3px] border-white overflow-hidden bg-white shadow-xl">
                      <img src="/pfp.png" alt="Profile" className="w-full h-full object-cover" />
                    </div>
                    {/* Button top-right of white area */}
                    <div className="flex justify-end pt-2">
                      <a href="https://www.whatnot.com/en-GB/user/togecheeks/shows" target="_blank" rel="noopener noreferrer" onClick={(e) => { e.stopPropagation(); window.open('https://www.whatnot.com/en-GB/user/togecheeks/shows', '_blank'); e.preventDefault(); }} className={`flex items-center gap-1.5 text-white px-3 py-1.5 rounded-lg text-xs font-semibold transition-all duration-200 active:scale-95 shadow-md flex-shrink-0 ${isLive ? 'bg-red-500 hover:bg-red-600' : 'bg-black hover:bg-slate-800'}`}>
                        {isLive ? (
                          <>
                            <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse inline-block"></span>
                            Watch Now
                          </>
                        ) : (
                          <>
                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                            View Profile
                          </>
                        )}
                      </a>
                    </div>
                    {/* Name + handle */}
                    <div className="pt-1 pb-3">
                      <div className="flex items-center gap-1.5">
                        <span className="text-black font-bold text-lg leading-none">cheeks</span>
                        {isLive ? (
                          <span className="flex items-center gap-1 bg-red-500 text-white text-[0.55rem] font-semibold px-1.5 py-0.5 rounded-full leading-none">
                            <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse inline-block"></span>LIVE
                          </span>
                        ) : (
                          <span className="flex items-center gap-1 bg-slate-200 text-slate-500 text-[0.55rem] font-semibold px-1.5 py-0.5 rounded-full leading-none">OFFLINE</span>
                        )}
                      </div>
                      <span className="text-black/60 text-xs font-medium leading-none block mt-0.5">@togecheeks</span>
                      <p className="text-slate-500 text-[0.65rem] leading-relaxed mt-1.5">Trading Cards, Collectibles, Custom Accessories & More ✨</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`absolute bottom-6 left-4 right-4 transition-all duration-1000 ease-out ${videoEnded ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}>
                <div className="space-y-3">
                  <a href="https://www.whatnot.com/user/togecheeks/shows" target="_blank" rel="noopener noreferrer" className="w-full rounded-full p-4 flex items-center space-x-4 hover:opacity-80 transition-all duration-200 transform hover:scale-[1.02] shadow-lg" style={{ backgroundColor: '#272527' }}>
                    <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#FADC00' }}><Bookmark className="h-5 w-5 text-black" /></div>
                    <span className="text-white font-medium text-sm">Bookmark the next Livestreams</span>
                  </a>
                  <a href="https://whatnot.com/invite/togecheeks" target="_blank" rel="noopener noreferrer" className="w-full rounded-full p-4 flex items-center space-x-4 hover:opacity-80 transition-all duration-200 transform hover:scale-[1.02] shadow-lg" style={{ backgroundColor: '#272527' }}>
                    <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#FADC00' }}><Gift className="h-5 w-5 text-black" /></div>
                    <span className="text-white font-medium text-sm">Get £10 FREE Pokemon Cards</span>
                  </a>
                  <a href="https://whatnot.com/invite/seller/togecheeks" target="_blank" rel="noopener noreferrer" className="w-full rounded-full p-4 flex items-center space-x-4 hover:opacity-80 transition-all duration-200 transform hover:scale-[1.02] shadow-lg" style={{ backgroundColor: '#272527' }}>
                    <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#FADC00' }}><DollarSign className="h-5 w-5 text-black" /></div>
                    <span className="text-white font-medium text-sm">Become a Seller and get £150 FREE</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── POKÉMON GO MODAL ── */}
      {showPogoModal && (
        <div className="fixed inset-0 z-[300] flex items-center justify-center p-4" style={{background:'rgba(0,0,0,0.7)', backdropFilter:'blur(4px)'}} onClick={() => setShowPogoModal(false)}>
          <div className="bg-slate-800 border border-slate-700/50 rounded-2xl shadow-2xl w-full max-w-xs p-5" onClick={e => e.stopPropagation()}>
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <img src="/pogo.png" alt="Pokémon GO" className="w-7 h-7 object-contain" />
                <span className="text-white font-bold text-base">Pokémon GO</span>
              </div>
              <button onClick={() => setShowPogoModal(false)} className="text-slate-400 hover:text-white transition-colors">
                <X className="h-5 w-5" />
              </button>
            </div>
            {/* Trainer name — centred title */}
            <div className="flex items-center justify-center gap-1.5 mb-1">
              <img src="/valor.webp" alt="Team Valor" className="w-4 h-4 object-contain" />
              <span className="text-white font-bold text-sm">togecheeks</span>
              <span className="text-slate-400 font-medium text-xs">Lv. 71</span>
            </div>
            {/* Trainer code box */}
            <div className="bg-slate-900/60 rounded-xl border border-slate-700/50 p-3 mb-3 mt-2">
              <div className="flex items-center justify-between">
                <span className="text-slate-400 font-medium" style={{fontSize:'0.7rem'}}>Trainer Code</span>
                <div className="relative flex items-center" style={{height:'1rem'}}>
                  <span className={`absolute right-0 flex items-center gap-1 transition-all duration-500 ${showCopiedToast ? 'opacity-100' : 'opacity-0'}`}>
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#4ade80" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    <span className="text-green-400 font-semibold whitespace-nowrap" style={{fontSize:'0.7rem'}}>Trainer Code Copied</span>
                  </span>
                  <span className={`transition-all duration-500 ${showCopiedToast ? 'opacity-0' : 'opacity-100'} text-white font-semibold font-mono whitespace-nowrap`} style={{fontSize:'0.7rem'}}>6644 6392 9998</span>
                </div>
              </div>
            </div>
            {/* QR code */}
            <div className="flex flex-col items-center gap-2">
              <img
                src={`https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=664463929998&bgcolor=1e293b&color=ffffff&margin=10`}
                alt="QR Code"
                className="rounded-xl w-44 h-44"
              />
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default CardExplorer;